// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  /* =========================================================
    DASHBOARD - COMPLETE RESPONSIVE CSS
  ========================================================= */


  /* =========================================================
    GLOBAL
  ========================================================= */

  * {
    box-sizing: border-box;
  }

  .no-scrollbar {
    background: #ffffff !important;
  }

  .dashboard-page {
    width: 100%;
    min-height: 100%;
    background: #ffffff;
    box-sizing: border-box;
  }

  .dashboard-main-width {
    width: min(980px, calc(100% - 30px));
    max-width: 980px;
    margin: 0 auto;
    box-sizing: border-box;
  }


  /* =========================================================
    SCHEME CARD
  ========================================================= */

  .scheme-card {
    width: 100%;
    max-width: 940px;
    min-height: 82px;

    margin: 0 auto 18px;
    padding: 10px 16px;

    background: #edf5fc;
    border: 1px solid #b7d9ff;
    border-radius: 10px;

    display: flex;
    align-items: center;
    justify-content: flex-start;

    box-sizing: border-box;
  }

  .scheme-label {
    flex-shrink: 0;

    font-size: 13px;
    font-weight: 600;

    color: #111111;

    margin-right: 10px;

    white-space: nowrap;
  }

  .scheme-select {
    width: 753px;
    max-width: calc(100% - 100px);
    height: 38px;

    padding: 6px 12px;

    border: 1px solid #d2d2d2;
    border-radius: 5px;

    background: #ffffff;

    font-size: 12px;
    color: #222222;

    outline: none;

    box-sizing: border-box;
  }


  /* =========================================================
    METRIC CARDS ROW
  ========================================================= */

  .metric-cards-row {
    width: 100%;
    max-width: 980px;

    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));

    gap: 20px;

    margin: 0 auto;

    box-sizing: border-box;
  }

  .metric-card-col {
    width: 100%;
    min-width: 0;
  background-color: #f3f8fd;
    box-sizing: border-box;
  }


  /* =========================================================
    METRIC CARD
  ========================================================= */

  .metric-card {
    width: 100%;
    height: 90px;

    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 10px 10px;

    border-radius: 12px;

    box-sizing: border-box;

    overflow: hidden;

    box-shadow: none;

    transition: transform 0.2s ease;
  }

  .metric-card:hover {
    transform: translateY(-2px);
  }


  /* Individual colors */

  .metric-card-col:nth-child(1) .metric-card {
    border: 0.8px solid #63a9ff;
    background: #f3f8fd;
  }

  .metric-card-col:nth-child(2) .metric-card {
    border: 0.8px solid #9a91ff;
    background: #f7f8fc;
  }

  .metric-card-col:nth-child(3) .metric-card {
    border: 0.8px solid #65c879;
    background: #f1fbf4;
  }

  .metric-card-col:nth-child(4) .metric-card {
    border: 0.8px solid #ff9b4a;
    background: #fcf5e8;
  }


  /* =========================================================
    METRIC ICON
  ========================================================= */

  .metric-icon {
    width: 40px;
    min-width: 40px;
    height: 40px;

    display: flex;
    align-items: center;
    justify-content: center;

    flex-shrink: 0;
  }

  .metric-icon img {
    width: 40px !important;
    height: 40px !important;

    object-fit: contain;
  }


  /* =========================================================
    METRIC CONTENT
  ========================================================= */

  .metric-content {
    flex: 1 1;
    min-width: 0;

    margin-left: 8px;
    margin-right: 4px;

    overflow: hidden;
  }

  .metric-label {
    font-size: 13px !important;
    font-weight: 550;

    color: #3f4344;

    line-height: 1.2;

    margin-bottom: 3px;

    text-decoration: none;

    white-space: nowrap;

    overflow: hidden;
    text-overflow: ellipsis;
    
  }

  .metric-value {
    font-size: 12px !important;
    font-weight: 800;

    color: #111111;

    white-space: nowrap;

    overflow: hidden;
    text-overflow: ellipsis;
  }


  /* =========================================================
    METRIC ARROW
  ========================================================= */

  .metric-arrow {
    width: 24px;
    min-width: 24px;
    height: 24px;

    display: flex;
    align-items: center;
    justify-content: center;

    flex-shrink: 0;
  }

  .metric-arrow-img {
    width: 23px !important;
    height: 23px !important;

    object-fit: contain;

    cursor: pointer;
  }


  /* =========================================================
    PROJECT DETAILS CARD
  ========================================================= */

  .project-details-card {
    width: 100%;
    max-width: 940px;

    margin: 16px auto 10px;
    padding: 16px;

    background: #ffffff;

    border-radius: 12px;

    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);

    display: flex;
    flex-direction: column;

    box-sizing: border-box;

    overflow: hidden;
  }


  /* =========================================================
    PROJECT HEADER
  ========================================================= */

  .project-header {
    width: 100%;

    min-height: 32px;

    display: flex;
    align-items: center;
    justify-content: space-between;

    gap: 15px;

    margin-bottom: 14px;

    box-sizing: border-box;
  }

  .first-header {
    min-width: 0;

    display: flex;
    align-items: center;

    gap: 7px;
  }

  .first-header img {
    width: 22px;
    height: 22px;

    margin-bottom: 0;

    flex-shrink: 0;
  }

  .project-title {
    min-width: 0;

    margin: 0;

    font-size: 16px;
    font-weight: 700;

    color: #111111;

    white-space: nowrap;
margin-top:0px;
    overflow: hidden;
    text-overflow: ellipsis;
  }


  /* =========================================================
    SEARCH
  ========================================================= */

  .search-container {
    width: 272px;
    min-width: 200px;
    height: 34px;

    display: flex;
    align-items: center;

    flex-shrink: 0;

    background: #ffffff;

    border: 1px solid #b9c7dc;
    border-radius: 6px;

    padding: 0 9px;

    box-sizing: border-box;
  }

  .search-input {
    width: 100%;
    min-width: 0;

    border: none;

    background: transparent;

    outline: none;

    padding: 4px 5px;

    font-size: 12px;

    color: #333333;
  }

  .search-input::placeholder {
    color: #8b9bb7;

    font-weight: 600;
  }

  .search-icon {
    width: 17px;
    height: 17px;

    margin-right: 6px;

    flex-shrink: 0;

    opacity: 1;
  }


  /* =========================================================
    NORMAL TABLE WRAPPER
  ========================================================= */

  .table-wrapper {
    width: 100%;
    max-width: 100%;

    overflow-x: auto;
    overflow-y: auto;

    background: #ffffff;

    border-radius: 6px;

    position: relative;

    box-sizing: border-box;
  }

  .table-wrapper::-webkit-scrollbar {
    height: 6px;
    width: 6px;
  }

  .table-wrapper::-webkit-scrollbar-track {
    background: #f5f7fa;
  }

  .table-wrapper::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
  }


  /* =========================================================
    MAIN PROJECT TABLE
  ========================================================= */

  .project-table {
    width: 100%;

    border-collapse: collapse;

    table-layout: fixed;

    background: #ffffff;

    font-family: "Inter", sans-serif;

    margin: 0;
  }


  /* Header */

  .project-table thead {
    background: #e4ebfd;
  }

  .project-table thead tr {
    height: 34px;

    background: #e4eaff;
  }

  .project-table thead th {
    height: 34px;

    padding: 7px 6px;

    background: #e4eaff !important;

    color: #222222 !important;

    border: 1px solid #d8deed;

    font-size: 14px;

    font-weight: 600;

    text-align: center;

    vertical-align: middle;

    white-space: nowrap;

    box-sizing: border-box;

    position: sticky;

    top: 0;

    z-index: 10;
  }


  /* Body */

  .project-table tbody tr {
    height: 38px;
  }

  .project-table tbody tr:nth-child(odd) {
    background: #fdfdfd;
  }

  .project-table tbody tr:nth-child(even) {
    background: #f8f8fb;
  }

  .project-table tbody td {
    height: 38px;

    padding: 7px;

    border: 1px solid #e2e6ee;

    color: #171717;

    font-size: 13px;

    font-weight: 500;

    line-height: 1.25;

    text-align: center;

    vertical-align: middle;

    box-sizing: border-box;

    overflow: visible;
  }


  /* Project name */

  .project-table tbody td:nth-child(2) {
    text-align: left;

    padding-left: 12px;

    white-space: normal;

    word-break: normal;

    overflow-wrap: break-word;
  }


  /* Agency */

  .project-table tbody td:nth-child(3) {
    text-align: center;

    white-space: nowrap;
  }


  /* Approved cost */

  .project-table tbody td.approved-cost {
    color: #009b63;

    font-weight: 700;

    text-align: center;

    white-space: nowrap;
  }

  .project-table .approved-icon {
    width: 14px;
    height: 14px;

    vertical-align: middle;

    margin-right: 4px;
  }


  /* Demand */

  .project-table tbody td.demand-amount {
    color: #111111;

    font-weight: 500;

    text-align: center;
  }


  /* Limit */

  .project-table tbody td.limit-amount {
    color: #1687e8;

    font-weight: 600;

    text-align: center;
  }


  /* Balance */

  .project-table tbody td.balance-positive {
    color: #008f5a;

    font-weight: 600;
  }

  .project-table tbody td.balance-negative {
    color: #e1261c;

    font-weight: 600;
  }


  /* =========================================================
    PROJECT TABLE COLUMN WIDTHS
  ========================================================= */

  .project-table.six-column th:nth-child(1),
  .project-table.six-column td:nth-child(1) {
    width: 8%;
  }

  .project-table.six-column th:nth-child(2),
  .project-table.six-column td:nth-child(2) {
    width: 23%;
  }

  .project-table.six-column th:nth-child(3),
  .project-table.six-column td:nth-child(3) {
    width: 20%;
  }

  .project-table.six-column th:nth-child(4),
  .project-table.six-column td:nth-child(4) {
    width: 18%;
  }

  .project-table.six-column th:nth-child(5),
  .project-table.six-column td:nth-child(5) {
    width: 15%;
  }

  .project-table.six-column th:nth-child(6),
  .project-table.six-column td:nth-child(6) {
    width: 16%;
  }


  /* 7 columns */

  .project-table.seven-column th:nth-child(1),
  .project-table.seven-column td:nth-child(1) {
    width: 7%;
  }

  .project-table.seven-column th:nth-child(2),
  .project-table.seven-column td:nth-child(2) {
    width: 19%;
  }

  .project-table.seven-column th:nth-child(3),
  .project-table.seven-column td:nth-child(3) {
    width: 17%;
  }

  .project-table.seven-column th:nth-child(4),
  .project-table.seven-column td:nth-child(4) {
    width: 17%;
  }

  .project-table.seven-column th:nth-child(5),
  .project-table.seven-column td:nth-child(5) {
    width: 13%;
  }

  .project-table.seven-column th:nth-child(6),
  .project-table.seven-column td:nth-child(6) {
    width: 14%;
  }

  .project-table.seven-column th:nth-child(7),
  .project-table.seven-column td:nth-child(7) {
    width: 13%;
  }


  /* No records */

  .project-table .no-records {
    text-align: center !important;

    padding: 14px !important;

    color: #777777;

    font-size: 12px;
  }

  /* =========================================================
    DEMAND AGAINST LIABILITY
    SAME STRUCTURE AS PROJECT DETAILS
  ========================================================= */

  .demand-liability-table-wrapper {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    overflow: hidden;
  }

  .demand-liability-scroll {
    width: 100%;
    max-width: 100%;

    overflow-x: auto;
    overflow-y: auto;

    background: #ffffff;
    border-radius: 6px;

    position: relative;
    box-sizing: border-box;

    -webkit-overflow-scrolling: touch;
  }

  .demand-liability-scroll::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  .demand-liability-scroll::-webkit-scrollbar-track {
    background: #f5f7fa;
  }

  .demand-liability-scroll::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
  }


     .demand-liability-table {
  width: 100% !important;
  min-width: 0 !important;
  border-collapse: collapse;
  table-layout: fixed;
}
  


  /* =========================================================
    DEMAND TABLE COLUMN WIDTHS
  ========================================================= */

  .demand-liability-table th:nth-child(1),
  .demand-liability-table td:nth-child(1) {
    width: 65px;
  }

  .demand-liability-table th:nth-child(2),
  .demand-liability-table td:nth-child(2) {
    width: 190px;
  }

  .demand-liability-table th:nth-child(3),
  .demand-liability-table td:nth-child(3) {
    width: 110px;
  }

  .demand-liability-table th:nth-child(4),
  .demand-liability-table td:nth-child(4) {
    width: 115px;
  }

  .demand-liability-table th:nth-child(5),
  .demand-liability-table td:nth-child(5) {
    width: 125px;
  }

  .demand-liability-table th:nth-child(6),
  .demand-liability-table td:nth-child(6) {
    width: 125px;
  }

  .demand-liability-table th:nth-child(7),
  .demand-liability-table td:nth-child(7) {
    width: 125px;
  }

  .demand-liability-table th:nth-child(8),
  .demand-liability-table td:nth-child(8) {
    width: 130px;
  }

  .demand-liability-table th:nth-child(9),
  .demand-liability-table td:nth-child(9) {
    width: 115px;
  }


  /* =========================================================
    HEADER - SAME AS PROJECT DETAILS
  ========================================================= */

  .demand-liability-table thead {
    background: #e4eaff;
  }

  .demand-liability-table thead tr {
    height: 34px;
    background: #e4eaff;
  }

  .demand-liability-table thead th {
    height: 34px;

    padding: 7px 6px !important;

    background: #e4eaff !important;

    color: #222222 !important;

    border: 1px solid #d8deed !important;

    font-size: 14px !important;

    font-weight: 600 !important;

    text-align: center !important;

    vertical-align: middle;

    white-space: nowrap;

    line-height: 1.2;

    box-sizing: border-box;

    position: sticky;

    top: 0;

    z-index: 10;
  }


  /* =========================================================
    BODY - SAME AS PROJECT DETAILS
  ========================================================= */

  .demand-liability-table tbody tr {
    height: 38px;
  }

  .demand-liability-table tbody tr:nth-child(odd) {
    background: #ffffff;
  }

  .demand-liability-table tbody tr:nth-child(even) {
    background: #f5f8fc;
  }

  .demand-liability-table tbody td {
    height: 38px;

    padding: 7px;

    border: 1px solid #e2e6ee !important;

    color: #171717;

    font-size: 13px !important;

    font-weight: 500;

    line-height: 1.25;

    text-align: center;

    vertical-align: middle;

    white-space: nowrap;

    box-sizing: border-box;
  }


  /* Project name */

  .demand-liability-table tbody td:nth-child(2) {
    text-align: left;

    padding-left: 12px;

    white-space: normal;

    word-break: normal;

    overflow-wrap: break-word;
  }


  /* =========================================================
    AMOUNT COLORS
  ========================================================= */

  .demand-liability-table .red-amount {
    color: #e1261c !important;
    font-weight: 600;
  }

  .demand-liability-table .positive-balance {
    color: #008f5a !important;
    font-weight: 600;
  }

  .demand-liability-table .negative-balance {
    color: #e1261c !important;
    font-weight: 600;
  }


  /* Demand header */

  .demand-liability-table thead th {
    height: 34px;

    padding: 7px 6px !important;

    background: #e3eaff !important;

    color: #202020 !important;

    border: 1px solid #d7ddef !important;

    font-size: 14px !important;

    font-weight: 600 !important;

    text-align: center !important;

    vertical-align: middle;

    white-space: normal;

    line-height: 1.2;
  }


  /* Demand body */

  .demand-liability-table tbody tr {
    height: 38px;
  }

  .demand-liability-table tbody tr:nth-child(odd) {
    background: #ffffff;
  }

  .demand-liability-table tbody tr:nth-child(even) {
    background: #f3f8fd;
  }

  .demand-liability-table tbody td {
    height: 38px;

    padding: 7px 8px !important;

    border: 1px solid #e2e6ee !important;

    font-size: 12px !important;

    font-weight: 500;

    color: #111111;

    text-align: center;

    vertical-align: middle;

    white-space: nowrap;

    box-sizing: border-box;
  }


  /* Project name */

  .demand-project-name {
    text-align: left !important;

    padding-left: 14px !important;

    white-space: normal !important;

    line-height: 1.25;
  }


  /* Red amounts */

  .demand-liability-table .red-amount {
    color: #e11d23 !important;

    font-weight: 500;
  }


  /* =========================================================
    STATUS
  ========================================================= */

  .demand-liability-table td:last-child {
    text-align: center;

    white-space: nowrap;

    overflow: visible;
  }

  .demand-liability-table .status-pending {
    width: 90px;

    min-width: 90px;

    height: 28px;

    margin: 0 auto;

    padding: 0 8px;

    background: #e11d23 !important;

    color: #ffffff !important;

    border-radius: 16px;

    display: inline-flex;

    align-items: center;

    justify-content: center;

    gap: 4px;

    font-size: 12px;

    font-weight: 600;

    white-space: nowrap;

    box-sizing: border-box;
  }

  .demand-liability-table .status-approved {
    width: 90px;

    min-width: 90px;

    height: 28px;

    margin: 0 auto;

    padding: 0 8px;

    border-radius: 16px;

    display: inline-flex;

    align-items: center;

    justify-content: center;

    gap: 4px;

    font-size: 12px;

    font-weight: 600;

    white-space: nowrap;

    box-sizing: border-box;
  }


  /* =========================================================
    PAGINATION
  ========================================================= */

  .demand-pagination {
    width: 100%;
    max-width: 100%;

    min-height: 42px;

    display: flex;

    align-items: center;

    justify-content: space-between;

    gap: 15px;

    margin-top: 12px;

    padding: 8px 4px;

    background: #ffffff;

    box-sizing: border-box;

    overflow: visible !important;
  }

  .demand-showing-text {
    flex-shrink: 0;

    margin: 0;

    font-size: 12px !important;

    font-weight: 500;

    color: #333333;

    white-space: nowrap;
  }

  .demand-pagination-controls {
    display: flex;

    align-items: center;

    justify-content: flex-end;

    flex-wrap: nowrap;

    gap: 18px;

    margin-left: auto;
  }

  .demand-page-btn {
    border: none;

    background: transparent;

    color: #2ea4e7;

    font-size: 12px !important;

    font-weight: 500;

    padding: 0;

    cursor: pointer;

    white-space: nowrap;
  }

  .demand-page-btn:hover:not(:disabled) {
    color: #147fc0;
  }

  .demand-page-btn:disabled,
  .demand-page-btn.disabled {
    color: #aaaaaa;

    cursor: not-allowed;

    opacity: 0.6;
  }

  .demand-page-numbers {
    display: flex;

    align-items: center;

    gap: 14px;
  }

  .demand-page-number {
    border: none;

    background: transparent;

    color: #444444;

    font-size: 12px !important;

    font-weight: 500;

    padding: 0;

    min-width: 12px;

    cursor: pointer;
  }

  .demand-page-number:hover {
    color: #2ea4e7;
  }

  .demand-page-number.active {
    color: #2ea4e7;

    font-size: 12px !important;

    font-weight: 600;

    text-decoration: underline;
  }

  .demand-page-dots {
    color: #777777;

    font-size: 12px !important;
  }


  /* =========================================================
    OLD PAGINATION SUPPORT
  ========================================================= */

  .pagination-footer {
    display: flex;

    align-items: center;

    justify-content: space-between;

    padding-top: 10px;

    background: #ffffff;

    box-sizing: border-box;

    width: 100%;
  }

  .pagination-footer p {
    margin: 0;

    font-size: 12px;
  }

  .pagination-controls {
    display: flex;

    align-items: center;

    gap: 14px;
  }

  .pagination-btn {
    background: transparent;

    color: #777777;

    border: none;

    cursor: pointer;

    font-size: 12px;

    padding: 0;
  }

  .pagination-btn-active {
    background: transparent;

    color: #2ea4e7;

    border: none;

    font-size: 12px;

    font-weight: 600;

    text-decoration: underline;
  }


  /* =========================================================
    DESKTOP
    > 1200px
  ========================================================= */

  @media (min-width: 1201px) {

    .dashboard-main-width {
      width: 940px;
    }

    .metric-cards-row {
      width: 940px;

      grid-template-columns: repeat(4, minmax(0, 1fr));

      gap: 20px;
    }

    .project-details-card {
      width: 940px;
    }

    .scheme-card {
      width: 940px;
    }
  }


  /* =========================================================
    LAPTOP
    993px - 1200px
  ========================================================= */

  @media (max-width: 1200px) {

    .dashboard-main-width {
      width: calc(100% - 30px);

      max-width: 940px;
    }

    .scheme-card {
      width: 100%;
    }

    .scheme-select {
      width: min(753px, calc(100% - 110px));
    }

    .metric-cards-row {
      width: 100%;

      gap: 14px;
    }

    .project-details-card {
      width: 100%;
    }

    .project-header {
      gap: 12px;
    }

    .search-container {
      width: 240px;

      min-width: 200px;
    }
  }


  /* =========================================================
    TABLET
    769px - 992px
  ========================================================= */

  @media (max-width: 992px) {

    .dashboard-main-width {
      width: calc(100% - 24px);
    }


    /* Scheme */

    .scheme-card {
      min-height: 78px;

      padding: 10px 14px;
    }

    .scheme-select {
      flex: 1 1;

      width: auto;

      max-width: none;
    }


    /* Cards */

    .metric-cards-row {
      grid-template-columns: repeat(2, minmax(0, 1fr));

      gap: 14px;
    }

    .metric-card {
      height: 80px;
    }


    /* Project */

    .project-details-card {
      padding: 14px;
    }


    /* Header */

    .project-header {
      gap: 10px;
    }

    .search-container {
      width: 220px;

      min-width: 180px;
    }


    /* Normal table */

    .table-wrapper {
      overflow-x: auto;
    }

    .project-table {
      min-width: 750px;
    }


    /* Demand table */

    .demand-liability-table {
      width: 1000px !important;

      min-width: 1000px !important;
    }
  }


  /* =========================================================
    MOBILE TABLET
    577px - 768px
  ========================================================= */

  @media (max-width: 768px) {

    .dashboard-main-width {
      width: calc(100% - 20px);
    }


    /* Scheme */

    .scheme-card {
      min-height: auto;

      flex-direction: column;

      align-items: stretch;

      justify-content: center;

      gap: 7px;

      padding: 12px;
    }

    .scheme-label {
      margin-right: 0;
  font-weight: 400;
      font-size: 11px;
    }

    .scheme-select {
      width: 100%;

      max-width: none;

      height: 36px;
    }


    /* Metric */

    .metric-cards-row {
      grid-template-columns: repeat(2, minmax(0, 1fr));

      gap: 12px;
    }

    .metric-card {
      height: 78px;

      padding: 7px 8px;
    }

    .metric-icon {
      width: 36px;

      min-width: 36px;

      height: 36px;
    }

    .metric-icon img {
      width: 36px !important;

      height: 36px !important;
    }

    .metric-label {
      font-size: 10px !important;
    }

    .metric-value {
      font-size: 11px !important;
    }

    .metric-arrow {
      width: 22px;

      min-width: 22px;
    }

    .metric-arrow-img {
      width: 21px !important;

      height: 21px !important;
    }


    /* Project card */

    .project-details-card {
      padding: 12px;

      margin-top: 12px;
    }


    /* Header */

    .project-header {
      flex-direction: column;

      align-items: stretch;

      gap: 10px;
    }

    .first-header {
      width: 100%;
    }

    .project-title {
      font-size: 12px;
    }


    /* Search */

    .search-container {
      width: 100%;

      min-width: 0;

      height: 34px;
    }


    /* Normal table */

    .table-wrapper {
      width: 100%;

      overflow-x: auto;
    }

    .project-table {
      min-width: 750px;
    }


    /* Demand */

    .demand-liability-scroll {
      width: 100%;

      overflow-x: auto;

      overflow-y: hidden;

      -webkit-overflow-scrolling: touch;
    }

    .demand-liability-table {
      width: 900px !important;

      min-width: 900px !important;
    }


    /* Pagination */

    .demand-pagination {
      flex-direction: column;

      align-items: center;

      justify-content: center;

      gap: 10px;

      padding: 10px 0;
    }

    .demand-showing-text {
      width: 100%;

      text-align: center;

      font-size: 11px !important;
    }

    .demand-pagination-controls {
      width: 100%;

      justify-content: center;

      margin-left: 0;

      gap: 14px;

      flex-wrap: wrap;
    }

    .demand-page-numbers {
      gap: 10px;
    }

    .demand-page-btn,
    .demand-page-number,
    .demand-page-dots {
      font-size: 11px !important;
    }


    /* Old pagination */

    .pagination-footer {
      flex-direction: column;

      gap: 10px;

      align-items: center;
    }

    .pagination-controls {
      justify-content: center;

      flex-wrap: wrap;
    }
  }


  /* =========================================================
    MOBILE
    401px - 576px
  ========================================================= */

  @media (max-width: 576px) {

    .dashboard-main-width {
      width: calc(100% - 16px);
    }


    /* Scheme */

    .scheme-card {
      padding: 10px;

      margin-bottom: 12px;
    }

    .scheme-label {
      font-size: 10px;
    }

    .scheme-select {
      height: 34px;

      font-size: 16px;
    }


    /* Metric cards */

    .metric-cards-row {
      grid-template-columns: 1fr;

      gap: 10px;
    }

    .metric-card {
      height: 72px;

      padding: 7px 10px;
    }

    .metric-icon {
      width: 36px;

      min-width: 36px;
    }

    .metric-content {
      margin-left: 7px;
    }

    .metric-label {
      font-size: 10px !important;
    }

    .metric-value {
      font-size: 11px !important;
    }


    /* Project */

    .project-details-card {
      padding: 10px;

      border-radius: 9px;

      margin-top: 10px;
    }

    .first-header img {
      width: 20px;

      height: 20px;
    }

    .project-title {
      font-size: 11px;
    }


    /* Normal table */

    .project-table {
      min-width: 700px;
    }

    .project-table thead th {
      font-size: 9px !important;
    }

    .project-table tbody td {
      font-size: 9px !important;
    }


    /* Demand */

    .demand-liability-table {
      width: 850px !important;

      min-width: 850px !important;
    }

    .demand-liability-table thead th {
      font-size: 14px !important;
    }

    .demand-liability-table tbody td {
      font-size: 9px !important;
    }


    /* Status */

    .demand-liability-table .status-pending,
    .demand-liability-table .status-approved {
      width: 70px;

      min-width: 70px;

      height: 25px;

      font-size: 9px;
    }


    /* Pagination */

    .demand-pagination {
      padding: 8px 0;

      gap: 8px;
    }

    .demand-showing-text {
      font-size: 10px !important;
    }

    .demand-pagination-controls {
      gap: 9px;
    }

    .demand-page-numbers {
      gap: 8px;
    }

    .demand-page-btn,
    .demand-page-number,
    .demand-page-dots {
      font-size: 10px !important;
    }
  }


  /* =========================================================
    SMALL MOBILE
    <= 400px
  ========================================================= */

  @media (max-width: 400px) {

    .dashboard-main-width {
      width: calc(100% - 12px);
    }


    /* Metric */

    .metric-card {
      height: 68px;
    }

    .metric-icon {
      width: 32px;

      min-width: 32px;

      height: 32px;
    }

    .metric-icon img {
      width: 32px !important;

      height: 32px !important;
    }

    .metric-label {
      font-size: 9px !important;
    }

    .metric-value {
      font-size: 10px !important;
    }


    /* Project */

    .project-details-card {
      padding: 8px;
    }

    .project-title {
      font-size: 10px;
    }


    /* Normal table */

    .project-table {
      min-width: 650px;
    }


    /* Demand */

    .demand-liability-table {
      width: 800px !important;

      min-width: 800px !important;
    }

    .demand-liability-table thead th {
      font-size: 8px !important;
    }

    .demand-liability-table tbody td {
      font-size: 8px !important;
    }


    /* Status */

    .demand-liability-table .status-pending,
    .demand-liability-table .status-approved {
      width: 65px;

      min-width: 65px;

      height: 24px;

      font-size: 8px;
    }


    /* Pagination */

    .demand-pagination {
      gap: 7px;
    }

    .demand-pagination-controls {
      gap: 7px;
    }

    .demand-page-numbers {
      gap: 6px;
    }

    .demand-page-btn,
    .demand-page-number,
    .demand-page-dots {
      font-size: 9px !important;
    }
  }


  /* =========================================================
    TOUCH / MOBILE SCROLL
  ========================================================= */

  @media (hover: none) and (pointer: coarse) {

    .table-wrapper,
    .demand-liability-scroll {
      -webkit-overflow-scrolling: touch;
    }
  }

  .metric-card {
  width: 100%;
  min-height: 90px;   /* instead of fixed height */
  height: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border-radius: 12px;
  box-sizing: border-box;
  transition: transform 0.2s ease;
}
.metric-content {
  flex: 1 1;
  min-width: 0;
  margin-left: 8px;
  margin-right: 4px;
}
.metric-label {
  font-size: 13px !important;
  font-weight: 550;
  color: #3f4344;
  line-height: 1.25;
  margin-bottom: 3px;

  white-space: normal;      /* allow 2 lines */
  overflow: visible;
  text-overflow: unset;
  word-break: break-word;
}

.scheme-card {
  width: 94%;
  min-height: 82px;

  background: #f0f7ff;
  border: 1px solid #9acbff;
  border-radius: 10px;

  display: flex;
  align-items: center;

  padding: 12px 16px;
  margin: 18px auto;

  box-sizing: border-box;
}

.scheme-label {
  flex: 0 0 auto;

  font-size: 14px;
  font-weight: 600;
  color: #111827;

  margin-right: 6px;
}

.scheme-select-wrapper {
  width: 78%;
  max-width: 720px;
}

.scheme-select {
  width: 100%;
}

.scheme__control {
  min-height: 38px !important;
  height: 38px !important;

  border: 1px solid #c7c7c7 !important;
  border-radius: 5px !important;

  background: #fff !important;

  box-shadow: none !important;
}

.scheme__control:hover {
  border-color: #aaa !important;
}

.scheme__control--is-focused {
  border-color: #2684ff !important;
  box-shadow: none !important;
}

.scheme__value-container {
  height: 36px !important;
  padding: 0 10px !important;
}

.scheme__placeholder {
  color: #555 !important;
  font-size: 14px;
}

.scheme__single-value {
  font-size: 14px;
  color: #111827 !important;
}

.scheme__indicators {
  height: 36px;
}

.scheme__indicator {
  padding: 8px !important;
}

.scheme__indicator-separator {
  display: none;
}

.scheme__menu {
  z-index: 9999;
}



  /* 22-10 static msg */

.demand-liability-scroll {
  position: relative;
  width: 100%;
  overflow-x: auto;
}

.demand-no-records {
  position: sticky;
  left: 0;
  width: 100%;
  min-width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  color: #555;
  font-size: 14px;
  box-sizing: border-box;
}


/* 28-10 */
/* =========================================================
   MAIN DASHBOARD (matches design image)
========================================================= */
.pd-page { background: #eaebff; padding: 0 0 20px; }

.pd-title-wrap { padding: 12px 10px 10px; }
.pd-subtitle { font-size: 10px; color: #6b7280; font-weight: 500; }
.pd-title { font-size: 14px; font-weight: 700; color: #111827; }

/* Scheme bar */
.pd-scheme-bar {
  display: flex; align-items: center; gap: 18px;
  background:linear-gradient(rgb(4, 76, 146), rgb(0, 113, 188), rgb(2, 47, 90)); padding: 22px 34px; margin-bottom: 16px;
}
.pd-scheme-label { color: #fff; font-size: 12px; font-weight: 600; margin: 0; white-space: nowrap; }
.pd-scheme-select { flex: 1 1; }
.pd-scheme-bar .scheme__control {
  background: #fff !important; border: 1px solid #2d4f8f !important;
  min-height: 34px !important; height: 34px !important; border-radius: 6px !important;
}
.pd-scheme-bar .scheme__value-container { height: 32px !important; }
.pd-scheme-bar .scheme__placeholder,
.pd-scheme-bar .scheme__single-value,
.pd-scheme-bar .scheme__input-container { color:#726b6b !important; font-size: 12px; }
.pd-scheme-bar .scheme__indicator { color: #726b6b !important; padding: 6px !important; }
.pd-scheme-bar .scheme__menu { color: #111; }

/* White cards */
.pd-card {
  background: #fff; border-radius: 12px; padding: 16px 20px;
  margin: 0 20px 18px; box-shadow: 0 2px 8px rgba(0, 0, 0, .12);
}
.pd-card-title { font-size: 16px; font-weight: 700; color: #111827; margin-bottom: 14px; }

/* Metric cards */
.pd-metrics { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 24px; }
.pd-metric {
  position: relative; border: 1px solid; border-radius: 12px;
  padding: 14px 16px 12px; min-height: 112px;
  display: flex; flex-direction: column;
}
.pd-metric-arrow {
  position: absolute; top: 10px; right: 10px; width: 20px; height: 20px;
  border-radius: 50%; display: flex; align-items: center; justify-content: center;
}
.pd-metric-icon {
  width: 34px; height: 34px; border-radius: 50%; margin-bottom: 8px;
  display: flex; align-items: center; justify-content: center;
}
.pd-metric-icon img { width: 20px; height: 20px; object-fit: contain; }
.pd-metric-label { font-size: 14px; font-weight: 600; color: #222; }
.pd-metric-value { font-size: 12px; font-weight: 800; color: #111; margin: 2px 0 10px; }
.pd-metric-bar { margin-top: auto; height: 4px; border-radius: 4px; background: #c9ccd1; overflow: hidden; }
.pd-metric-bar span { display: block; height: 100%; border-radius: 4px; }

.pd-blue   { color: #1a73c8; }
.pd-metric.pd-blue   { background: #f3f8fd; border-color: #3d87c9; }
.pd-metric.pd-blue .pd-metric-arrow, .pd-metric.pd-blue .pd-metric-bar span { background: #2e86d4; }
.pd-metric.pd-blue .pd-metric-icon { background: #dcebf8; }

.pd-metric.pd-purple { background: #f7f7fd; border-color: #9a91ff; }
.pd-metric.pd-purple .pd-metric-arrow, .pd-metric.pd-purple .pd-metric-bar span { background: #7b6df0; }
.pd-metric.pd-purple .pd-metric-icon { background: #e6e3fb; }

.pd-metric.pd-green  { background: #f1fbf4; border-color: #7fcf93; }
.pd-metric.pd-green .pd-metric-arrow, .pd-metric.pd-green .pd-metric-bar span { background: #3a9d8c; }
.pd-metric.pd-green .pd-metric-icon { background: #d8f0dd; }

.pd-metric.pd-orange { background: #fffaf1; border-color: #f3a65e; }
.pd-metric.pd-orange .pd-metric-arrow, .pd-metric.pd-orange .pd-metric-bar span { background: #ec8a35; }
.pd-metric.pd-orange .pd-metric-icon { background: #fbe7cf; }

/* Project details panel */
.pd-details-panel { background: #eef1f6; border-radius: 10px; padding: 14px 14px 16px; }
.pd-details-header { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 12px; }
.pd-details-title { display: flex; align-items: center; gap: 8px; font-size: 16px; font-weight: 700; color: #111; }
.pd-details-title img { width: 16px; height: 16px; }
.pd-search {
  display: flex; align-items: center; gap: 6px; width: 224px; height: 30px;
  background: #fff; border: 1px solid #d6dbe6; border-radius: 8px; padding: 0 10px;
}
.pd-search img { width: 20px; height: 20px; }
.pd-search input { border: none; outline: none; width: 100%; font-size: 12px; background: transparent; }

.pd-table-card {
  background: #fff; border-radius: 10px; padding: 16px 18px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, .12);
}
.pd-table-scroll { overflow-x: auto; }
.pd-table { width: 100%; border-collapse: collapse; font-size: 10px; }
.pd-table thead th {
  background: #2f7bd9; color: #fff; font-weight: 600; font-size: 12px;
  padding: 9px 8px; text-align: center; border: 1px solid #fff; white-space: nowrap;
}
.pd-table tbody td {
  padding: 10px 10px; border: 1px solid #fff; color: #111; font-weight: 500;
  vertical-align: middle; font-size: 12px;
}
.pd-table tbody tr:nth-child(odd)  { background: #e7f4fb; }
.pd-table tbody tr:nth-child(even) { background: #cfe5f2; }
.pd-table td.c { text-align: center; }
.pd-table td.l { text-align: center; }
.pd-table td.r { text-align: center; }
.pd-table td.pd-green { color: #0a9a55; font-weight: 700; text-align: center;}
.pd-table td.pd-blue  { color: #1a73c8; font-weight: 700; text-align: center;}
.pd-cost { font-weight: 700 !important; }			
.pd-cost img { width: 13px; height: 13px; margin-right: 8px; vertical-align: middle; }

/* Pagination */
.pd-pagination { display: flex; align-items: center; justify-content: space-between; margin-top: 14px; }
.pd-showing { margin: 0; font-size: 12px; font-weight: 600; color: #222; }
.pd-pages { display: flex; gap: 6px; }
.pd-pages button {
  min-width: 30px; height: 26px; border: none; border-radius: 4px; background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, .25); color: #444; font-size: 12px; cursor: pointer;
}
.pd-pages button.active { background: linear-gradient(180deg, #1c7fd6, #0f5fb0); color: #fff; font-weight: 700; }
.pd-pages button:disabled { opacity: .45; cursor: not-allowed; }

/* Responsive */
@media (max-width: 992px) { .pd-metrics { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
@media (max-width: 576px) {
  .pd-metrics { grid-template-columns: 1fr; }
  .pd-scheme-bar { flex-direction: column; align-items: stretch; gap: 8px; padding: 14px; }
  .pd-card { margin: 0 8px 14px; padding: 12px; }
  .pd-details-header, .pd-pagination { flex-direction: column; align-items: stretch; gap: 10px; }
  .pd-search { width: 100%; }
  .pd-pages { justify-content: center; }
  .pd-table { min-width: 650px; }
}


/* ---------- Project Overview: darker card colors ---------- */

/* 1. Demand Against Liability (blue) */
.pd-metric.pd-blue {
  background: #eaf3fc;
  border: 1.5px solid #1a6fc4;
}
.pd-metric.pd-blue .pd-metric-arrow,
.pd-metric.pd-blue .pd-metric-bar span { background: #1a6fc4; }
.pd-metric.pd-blue .pd-metric-icon { background: #bcd9f3; }

/* 2. Total Liability (purple) */
.pd-metric.pd-purple {
  background: #f0eefd;
  border: 1.5px solid #6c5ce7;
}
.pd-metric.pd-purple .pd-metric-arrow,
.pd-metric.pd-purple .pd-metric-bar span { background: #5b4bd5; }
.pd-metric.pd-purple .pd-metric-icon { background: #d3cdf8; }

/* 3. Available Balance (green) */
.pd-metric.pd-green {
  background: #e8f7ec;
  border: 1.5px solid #2e9e5b;
}
.pd-metric.pd-green .pd-metric-arrow,
.pd-metric.pd-green .pd-metric-bar span { background: #1f7a6d; }
.pd-metric.pd-green .pd-metric-icon { background: #bfe6c9; }

/* 4. Excess / Shortfall (orange) */
.pd-metric.pd-orange {
  background: #fff3e3;
  border: 1.5px solid #e8761a;
}
.pd-metric.pd-orange .pd-metric-arrow,
.pd-metric.pd-orange .pd-metric-bar span { background: #e8761a; }
.pd-metric.pd-orange .pd-metric-icon { background: #fad3a6; }

/* Darker grey track behind the progress bar */
.pd-metric-bar { background: #b4b9c2; height: 5px; }

/* Stronger text and more visible icons */
.pd-metric-label { color: #111827; font-weight: 700; }
.pd-metric-value { color: #0b0f1a; }
.pd-metric-icon img { opacity: 1; filter: saturate(1.6) contrast(1.15); }
/* Keep a disabled arrow (Demand = ₹0) readable, not washed out */
.pd-metric-arrow[style*="opacity: 0.4"] { opacity: 0.55 !important; }



/* Available Balance amount → green */
.pd-metric.pd-green .pd-metric-value { color: #1a9a4a; }

/* Excess / Sh
ortfall amount → red */
.pd-metric.pd-orange .pd-metric-value { color: #e11d23; }



/* Plain text pagination: ‹ Previous  1  Next › */
.pd-pages.pd-pages-text {
  display: flex;
  align-items: center;
  gap: 22px;
}

.pd-pages-text button {
  min-width: 0;
  height: auto;
  padding: 0;
  border: none;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
}

/* Previous / Next */
.pd-pages-text .pd-nav {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #2ea4e7;
}
.pd-pages-text .pd-nav:hover:not(:disabled) { color: #147fc0; }
.pd-pages-text .pd-nav:disabled {
  color: #b5b5b5;
  cursor: not-allowed;
  opacity: 1;
}
.pd-chev { font-size: 16px; line-height: 1; }

/* Page numbers */
.pd-pages-text .pd-num { color: #b5b5b5; }
.pd-pages-text .pd-num:hover { color: #2ea4e7; }
.pd-pages-text .pd-num.active {
  color: #2ea4e7;
  text-decoration: underline;
  text-underline-offset: 3px;
  background: transparent;   /* cancels the old blue box */
}

.pd-metric.pd-orange .pd-metric-arrow { display: none; }



/* ---------- Drill-down tables (same look as Project Details) ---------- */

/* Back button in the title */
.pd-back {
  width: 26px; height: 26px; padding: 0; margin-right: 4px;
  border: none; border-radius: 6px; background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, .2);
  display: inline-flex; align-items: center; justify-content: center; cursor: pointer;
}
.pd-back img { width: 14px; height: 14px; object-fit: contain; }
.pd-back:hover { background: #e7f4fb; }

/* Wide tables scroll sideways instead of squeezing */
.pd-table.pd-wide { min-width: 900px; }
.pd-table thead th { white-space: normal; line-height: 1.25; }

/* Cell colors */
.pd-table td.pd-link { color: #5295c9; font-weight: 600; }
.pd-table td.pd-red  { color: #e11d23; font-weight: 600; }

/* Status badges */
.pd-badge {
  display: inline-flex; align-items: center; justify-content: center;
  min-width: 74px; height: 22px; padding: 0 10px;
  border-radius: 12px; font-size: 10px; font-weight: 700; color: #fff;
}
.pd-badge.approved { background: #1a9a4a; }
.pd-badge.pending  { background: #e11d23; }

/* Empty state (stays centered even when the table scrolls) */
.pd-empty {
  position: sticky; left: 0; width: 100%;
  height: 90px; display: flex; align-items: center; justify-content: center;
  background: #fff; color: #555; font-size: 12px;
}

/* Pagination ellipsis */
.pd-pages-text .pd-dots { color: #b5b5b5; font-size: 12px; font-weight: 700; }

/* Mobile */
@media (max-width: 576px) {
  .pd-details-title span { font-size: 11px; }
}


/* Back button */
.pd-details-title .pd-back {
  width: 36px !important;
  height: 36px !important;
  min-width: 36px;
  padding: 0 !important;
  margin: 0 6px 0 0;
  border: none !important;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, .25);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-sizing: border-box;
}

.pd-details-title .pd-back img {
  width: 24px !important;     /* make bigger / smaller here */
  height: 24px !important;
  object-fit: contain;
  display: block;
}

.pd-details-title .pd-back:hover { background: #e7f4fb; }

/* ---------- Icon circle: solid color + white icon ---------- */
.pd-metric-icon {
  width: 36px;
  height: 36px;
}


.pd-metric.pd-blue   .pd-metric-icon { background: #1f5fa8; }
.pd-metric.pd-purple .pd-metric-icon { background: #8e3fb0; }
.pd-metric.pd-green  .pd-metric-icon { background: #1f8a5b; }
.pd-metric.pd-orange .pd-metric-icon { background: #d2691e; }

/* ---------- Arrow: outlined circle in the card color ---------- */
.pd-metric-arrow {
  width: 20px;
  height: 20px;
  background: transparent !important;
  border: 1.5px solid currentColor;
  box-sizing: border-box;
}
.pd-metric.pd-blue   .pd-metric-arrow { color: #2e86d4; }
.pd-metric.pd-purple .pd-metric-arrow { color: #8e3fb0; }
.pd-metric.pd-green  .pd-metric-arrow { color: #1f8a5b; }
.pd-metric.pd-orange .pd-metric-arrow { color: #d2691e; }

/* ---------- Card border + background (same family as the reference) ---------- */
.pd-metric.pd-blue   { background: #eef3fb; border: 1.5px solid #4a90d9; }
.pd-metric.pd-purple { background: #f6f0fa; border: 1.5px solid #a05cc0; }
.pd-metric.pd-green  { background: #e9f6ef; border: 1.5px solid #2e9e6b; }
.pd-metric.pd-orange { background: #fff4ea; border: 1.5px solid #e8903a; }

/* =========================================================
   TABLE: light-blue bordered style (all dashboard tables)
========================================================= */

/* Outer frame with rounded corners */
.pd-table {
  width: 100%;
  border-collapse: separate;      /* needed for rounded corners */
  border-spacing: 0;
  border: 1.5px solid #a9cdf5;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
}

/* Header */
.pd-table thead th {
  background: #2f7bd9;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  padding: 11px 8px;
  text-align: center;
  border: 0;
  border-right: 1px solid rgba(255, 255, 255, .45);
  border-bottom: 1px solid #a9cdf5;
}
.pd-table thead th:last-child { border-right: 0; }

/* Body cells: light-blue grid lines */
.pd-table tbody td {
  padding: 12px 10px;
  font-size: 12px;
  font-weight: 400;
  color: #111;
  border: 0;
  border-right: 1px solid #b7d6f4;
  border-bottom: 1px solid #b7d6f4;
  vertical-align: middle;
}
.pd-table tbody td:last-child { border-right: 0; }
.pd-table tbody tr:last-child td { border-bottom: 0; }

/* Row colors */
.pd-table tbody tr:nth-child(odd)  { background: #e6f3fc; }
.pd-table tbody tr:nth-child(even) { background: #cfe4f2; }
.pd-table tbody tr:hover { background: #bcdcf3; }

/* Alignment + amount colors */
.pd-table td.c { text-align: center; }
.pd-table td.l { text-align: center; padding-left: 14px; }
.pd-table td.r { text-align: center; padding-right: 16px; }
.pd-table td.pd-green { color: #12a05c; font-weight: 700; }
.pd-table td.pd-blue  { color: #2a7fd0; font-weight: 700; }
.pd-table td.pd-red   { color: #e11d23; font-weight: 700; }
.pd-table td.pd-link  { color: #5295c9; font-weight: 700; }

/* Approved cost with green tick */
.pd-cost { font-weight: 700 !important; }
.pd-cost img {
  width: 14px;
  height: 14px;
  margin-right: 10px;
  vertical-align: middle;
}
/* Tables: 4px corners */
.pd-table,
.budgetContainer .dg-panel .tableContainer table {
  border-radius: 5px !important;
}





.pd-metric:hover {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
  transition: all 0.2s ease;
}`, "",{"version":3,"sources":["webpack://./src/Components/admin/pages/ProjectDashboard/page.css"],"names":[],"mappings":"EAAE;;6DAE2D;;;EAG3D;;6DAE2D;;EAE3D;IACE,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,oCAAoC;IACpC,gBAAgB;IAChB,cAAc;IACd,sBAAsB;EACxB;;;EAGA;;6DAE2D;;EAE3D;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;;IAEhB,mBAAmB;IACnB,kBAAkB;;IAElB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;;IAEnB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;;IAE3B,sBAAsB;EACxB;;EAEA;IACE,cAAc;;IAEd,eAAe;IACf,gBAAgB;;IAEhB,cAAc;;IAEd,kBAAkB;;IAElB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,6BAA6B;IAC7B,YAAY;;IAEZ,iBAAiB;;IAEjB,yBAAyB;IACzB,kBAAkB;;IAElB,mBAAmB;;IAEnB,eAAe;IACf,cAAc;;IAEd,aAAa;;IAEb,sBAAsB;EACxB;;;EAGA;;6DAE2D;;EAE3D;IACE,WAAW;IACX,gBAAgB;;IAEhB,aAAa;IACb,gDAAgD;;IAEhD,SAAS;;IAET,cAAc;;IAEd,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd,yBAAyB;IACvB,sBAAsB;EACxB;;;EAGA;;6DAE2D;;EAE3D;IACE,WAAW;IACX,YAAY;;IAEZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;;IAE9B,kBAAkB;;IAElB,mBAAmB;;IAEnB,sBAAsB;;IAEtB,gBAAgB;;IAEhB,gBAAgB;;IAEhB,+BAA+B;EACjC;;EAEA;IACE,2BAA2B;EAC7B;;;EAGA,sBAAsB;;EAEtB;IACE,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;IAC3B,mBAAmB;EACrB;;;EAGA;;6DAE2D;;EAE3D;IACE,WAAW;IACX,eAAe;IACf,YAAY;;IAEZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;;IAEvB,mBAAmB;EACrB;;;EAGA;;6DAE2D;;EAE3D;IACE,SAAO;IACP,YAAY;;IAEZ,gBAAgB;IAChB,iBAAiB;;IAEjB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;;IAEhB,cAAc;;IAEd,gBAAgB;;IAEhB,kBAAkB;;IAElB,qBAAqB;;IAErB,mBAAmB;;IAEnB,gBAAgB;IAChB,uBAAuB;;EAEzB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;;IAEhB,cAAc;;IAEd,mBAAmB;;IAEnB,gBAAgB;IAChB,uBAAuB;EACzB;;;EAGA;;6DAE2D;;EAE3D;IACE,WAAW;IACX,eAAe;IACf,YAAY;;IAEZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;;IAEvB,mBAAmB;;IAEnB,eAAe;EACjB;;;EAGA;;6DAE2D;;EAE3D;IACE,WAAW;IACX,gBAAgB;;IAEhB,sBAAsB;IACtB,aAAa;;IAEb,mBAAmB;;IAEnB,mBAAmB;;IAEnB,yCAAyC;;IAEzC,aAAa;IACb,sBAAsB;;IAEtB,sBAAsB;;IAEtB,gBAAgB;EAClB;;;EAGA;;6DAE2D;;EAE3D;IACE,WAAW;;IAEX,gBAAgB;;IAEhB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;;IAE9B,SAAS;;IAET,mBAAmB;;IAEnB,sBAAsB;EACxB;;EAEA;IACE,YAAY;;IAEZ,aAAa;IACb,mBAAmB;;IAEnB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;;IAEZ,gBAAgB;;IAEhB,cAAc;EAChB;;EAEA;IACE,YAAY;;IAEZ,SAAS;;IAET,eAAe;IACf,gBAAgB;;IAEhB,cAAc;;IAEd,mBAAmB;AACvB,cAAc;IACV,gBAAgB;IAChB,uBAAuB;EACzB;;;EAGA;;6DAE2D;;EAE3D;IACE,YAAY;IACZ,gBAAgB;IAChB,YAAY;;IAEZ,aAAa;IACb,mBAAmB;;IAEnB,cAAc;;IAEd,mBAAmB;;IAEnB,yBAAyB;IACzB,kBAAkB;;IAElB,cAAc;;IAEd,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;;IAEZ,YAAY;;IAEZ,uBAAuB;;IAEvB,aAAa;;IAEb,gBAAgB;;IAEhB,eAAe;;IAEf,cAAc;EAChB;;EAEA;IACE,cAAc;;IAEd,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;;IAEZ,iBAAiB;;IAEjB,cAAc;;IAEd,UAAU;EACZ;;;EAGA;;6DAE2D;;EAE3D;IACE,WAAW;IACX,eAAe;;IAEf,gBAAgB;IAChB,gBAAgB;;IAEhB,mBAAmB;;IAEnB,kBAAkB;;IAElB,kBAAkB;;IAElB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;;EAGA;;6DAE2D;;EAE3D;IACE,WAAW;;IAEX,yBAAyB;;IAEzB,mBAAmB;;IAEnB,mBAAmB;;IAEnB,gCAAgC;;IAEhC,SAAS;EACX;;;EAGA,WAAW;;EAEX;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;;IAEZ,mBAAmB;EACrB;;EAEA;IACE,YAAY;;IAEZ,gBAAgB;;IAEhB,8BAA8B;;IAE9B,yBAAyB;;IAEzB,yBAAyB;;IAEzB,eAAe;;IAEf,gBAAgB;;IAEhB,kBAAkB;;IAElB,sBAAsB;;IAEtB,mBAAmB;;IAEnB,sBAAsB;;IAEtB,gBAAgB;;IAEhB,MAAM;;IAEN,WAAW;EACb;;;EAGA,SAAS;;EAET;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;;IAEZ,YAAY;;IAEZ,yBAAyB;;IAEzB,cAAc;;IAEd,eAAe;;IAEf,gBAAgB;;IAEhB,iBAAiB;;IAEjB,kBAAkB;;IAElB,sBAAsB;;IAEtB,sBAAsB;;IAEtB,iBAAiB;EACnB;;;EAGA,iBAAiB;;EAEjB;IACE,gBAAgB;;IAEhB,kBAAkB;;IAElB,mBAAmB;;IAEnB,kBAAkB;;IAElB,yBAAyB;EAC3B;;;EAGA,WAAW;;EAEX;IACE,kBAAkB;;IAElB,mBAAmB;EACrB;;;EAGA,kBAAkB;;EAElB;IACE,cAAc;;IAEd,gBAAgB;;IAEhB,kBAAkB;;IAElB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;;IAEZ,sBAAsB;;IAEtB,iBAAiB;EACnB;;;EAGA,WAAW;;EAEX;IACE,cAAc;;IAEd,gBAAgB;;IAEhB,kBAAkB;EACpB;;;EAGA,UAAU;;EAEV;IACE,cAAc;;IAEd,gBAAgB;;IAEhB,kBAAkB;EACpB;;;EAGA,YAAY;;EAEZ;IACE,cAAc;;IAEd,gBAAgB;EAClB;;EAEA;IACE,cAAc;;IAEd,gBAAgB;EAClB;;;EAGA;;6DAE2D;;EAE3D;;IAEE,SAAS;EACX;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,UAAU;EACZ;;;EAGA,cAAc;;EAEd;;IAEE,SAAS;EACX;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,UAAU;EACZ;;;EAGA,eAAe;;EAEf;IACE,6BAA6B;;IAE7B,wBAAwB;;IAExB,cAAc;;IAEd,eAAe;EACjB;;EAEA;;;6DAG2D;;EAE3D;IACE,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;;IAEf,gBAAgB;IAChB,gBAAgB;;IAEhB,mBAAmB;IACnB,kBAAkB;;IAElB,kBAAkB;IAClB,sBAAsB;;IAEtB,iCAAiC;EACnC;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;;KAGG;EACH,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;AACrB;;;;EAIE;;6DAE2D;;EAE3D;;IAEE,WAAW;EACb;;EAEA;;IAEE,YAAY;EACd;;EAEA;;IAEE,YAAY;EACd;;EAEA;;IAEE,YAAY;EACd;;EAEA;;IAEE,YAAY;EACd;;EAEA;;IAEE,YAAY;EACd;;EAEA;;IAEE,YAAY;EACd;;EAEA;;IAEE,YAAY;EACd;;EAEA;;IAEE,YAAY;EACd;;;EAGA;;6DAE2D;;EAE3D;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,YAAY;;IAEZ,2BAA2B;;IAE3B,8BAA8B;;IAE9B,yBAAyB;;IAEzB,oCAAoC;;IAEpC,0BAA0B;;IAE1B,2BAA2B;;IAE3B,6BAA6B;;IAE7B,sBAAsB;;IAEtB,mBAAmB;;IAEnB,gBAAgB;;IAEhB,sBAAsB;;IAEtB,gBAAgB;;IAEhB,MAAM;;IAEN,WAAW;EACb;;;EAGA;;6DAE2D;;EAE3D;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;;IAEZ,YAAY;;IAEZ,oCAAoC;;IAEpC,cAAc;;IAEd,0BAA0B;;IAE1B,gBAAgB;;IAEhB,iBAAiB;;IAEjB,kBAAkB;;IAElB,sBAAsB;;IAEtB,mBAAmB;;IAEnB,sBAAsB;EACxB;;;EAGA,iBAAiB;;EAEjB;IACE,gBAAgB;;IAEhB,kBAAkB;;IAElB,mBAAmB;;IAEnB,kBAAkB;;IAElB,yBAAyB;EAC3B;;;EAGA;;6DAE2D;;EAE3D;IACE,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;EAClB;;;EAGA,kBAAkB;;EAElB;IACE,YAAY;;IAEZ,2BAA2B;;IAE3B,8BAA8B;;IAE9B,yBAAyB;;IAEzB,oCAAoC;;IAEpC,0BAA0B;;IAE1B,2BAA2B;;IAE3B,6BAA6B;;IAE7B,sBAAsB;;IAEtB,mBAAmB;;IAEnB,gBAAgB;EAClB;;;EAGA,gBAAgB;;EAEhB;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;;IAEZ,2BAA2B;;IAE3B,oCAAoC;;IAEpC,0BAA0B;;IAE1B,gBAAgB;;IAEhB,cAAc;;IAEd,kBAAkB;;IAElB,sBAAsB;;IAEtB,mBAAmB;;IAEnB,sBAAsB;EACxB;;;EAGA,iBAAiB;;EAEjB;IACE,2BAA2B;;IAE3B,6BAA6B;;IAE7B,8BAA8B;;IAE9B,iBAAiB;EACnB;;;EAGA,gBAAgB;;EAEhB;IACE,yBAAyB;;IAEzB,gBAAgB;EAClB;;;EAGA;;6DAE2D;;EAE3D;IACE,kBAAkB;;IAElB,mBAAmB;;IAEnB,iBAAiB;EACnB;;EAEA;IACE,WAAW;;IAEX,eAAe;;IAEf,YAAY;;IAEZ,cAAc;;IAEd,cAAc;;IAEd,8BAA8B;;IAE9B,yBAAyB;;IAEzB,mBAAmB;;IAEnB,oBAAoB;;IAEpB,mBAAmB;;IAEnB,uBAAuB;;IAEvB,QAAQ;;IAER,eAAe;;IAEf,gBAAgB;;IAEhB,mBAAmB;;IAEnB,sBAAsB;EACxB;;EAEA;IACE,WAAW;;IAEX,eAAe;;IAEf,YAAY;;IAEZ,cAAc;;IAEd,cAAc;;IAEd,mBAAmB;;IAEnB,oBAAoB;;IAEpB,mBAAmB;;IAEnB,uBAAuB;;IAEvB,QAAQ;;IAER,eAAe;;IAEf,gBAAgB;;IAEhB,mBAAmB;;IAEnB,sBAAsB;EACxB;;;EAGA;;6DAE2D;;EAE3D;IACE,WAAW;IACX,eAAe;;IAEf,gBAAgB;;IAEhB,aAAa;;IAEb,mBAAmB;;IAEnB,8BAA8B;;IAE9B,SAAS;;IAET,gBAAgB;;IAEhB,gBAAgB;;IAEhB,mBAAmB;;IAEnB,sBAAsB;;IAEtB,4BAA4B;EAC9B;;EAEA;IACE,cAAc;;IAEd,SAAS;;IAET,0BAA0B;;IAE1B,gBAAgB;;IAEhB,cAAc;;IAEd,mBAAmB;EACrB;;EAEA;IACE,aAAa;;IAEb,mBAAmB;;IAEnB,yBAAyB;;IAEzB,iBAAiB;;IAEjB,SAAS;;IAET,iBAAiB;EACnB;;EAEA;IACE,YAAY;;IAEZ,uBAAuB;;IAEvB,cAAc;;IAEd,0BAA0B;;IAE1B,gBAAgB;;IAEhB,UAAU;;IAEV,eAAe;;IAEf,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,cAAc;;IAEd,mBAAmB;;IAEnB,YAAY;EACd;;EAEA;IACE,aAAa;;IAEb,mBAAmB;;IAEnB,SAAS;EACX;;EAEA;IACE,YAAY;;IAEZ,uBAAuB;;IAEvB,cAAc;;IAEd,0BAA0B;;IAE1B,gBAAgB;;IAEhB,UAAU;;IAEV,eAAe;;IAEf,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;;IAEd,0BAA0B;;IAE1B,gBAAgB;;IAEhB,0BAA0B;EAC5B;;EAEA;IACE,cAAc;;IAEd,0BAA0B;EAC5B;;;EAGA;;6DAE2D;;EAE3D;IACE,aAAa;;IAEb,mBAAmB;;IAEnB,8BAA8B;;IAE9B,iBAAiB;;IAEjB,mBAAmB;;IAEnB,sBAAsB;;IAEtB,WAAW;EACb;;EAEA;IACE,SAAS;;IAET,eAAe;EACjB;;EAEA;IACE,aAAa;;IAEb,mBAAmB;;IAEnB,SAAS;EACX;;EAEA;IACE,uBAAuB;;IAEvB,cAAc;;IAEd,YAAY;;IAEZ,eAAe;;IAEf,eAAe;;IAEf,UAAU;EACZ;;EAEA;IACE,uBAAuB;;IAEvB,cAAc;;IAEd,YAAY;;IAEZ,eAAe;;IAEf,gBAAgB;;IAEhB,0BAA0B;EAC5B;;;EAGA;;;6DAG2D;;EAE3D;;IAEE;MACE,YAAY;IACd;;IAEA;MACE,YAAY;;MAEZ,gDAAgD;;MAEhD,SAAS;IACX;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,YAAY;IACd;EACF;;;EAGA;;;6DAG2D;;EAE3D;;IAEE;MACE,wBAAwB;;MAExB,gBAAgB;IAClB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,qCAAqC;IACvC;;IAEA;MACE,WAAW;;MAEX,SAAS;IACX;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,SAAS;IACX;;IAEA;MACE,YAAY;;MAEZ,gBAAgB;IAClB;EACF;;;EAGA;;;6DAG2D;;EAE3D;;IAEE;MACE,wBAAwB;IAC1B;;;IAGA,WAAW;;IAEX;MACE,gBAAgB;;MAEhB,kBAAkB;IACpB;;IAEA;MACE,SAAO;;MAEP,WAAW;;MAEX,eAAe;IACjB;;;IAGA,UAAU;;IAEV;MACE,gDAAgD;;MAEhD,SAAS;IACX;;IAEA;MACE,YAAY;IACd;;;IAGA,YAAY;;IAEZ;MACE,aAAa;IACf;;;IAGA,WAAW;;IAEX;MACE,SAAS;IACX;;IAEA;MACE,YAAY;;MAEZ,gBAAgB;IAClB;;;IAGA,iBAAiB;;IAEjB;MACE,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;IAClB;;;IAGA,iBAAiB;;IAEjB;MACE,wBAAwB;;MAExB,4BAA4B;IAC9B;EACF;;;EAGA;;;6DAG2D;;EAE3D;;IAEE;MACE,wBAAwB;IAC1B;;;IAGA,WAAW;;IAEX;MACE,gBAAgB;;MAEhB,sBAAsB;;MAEtB,oBAAoB;;MAEpB,uBAAuB;;MAEvB,QAAQ;;MAER,aAAa;IACf;;IAEA;MACE,eAAe;EACnB,gBAAgB;MACZ,eAAe;IACjB;;IAEA;MACE,WAAW;;MAEX,eAAe;;MAEf,YAAY;IACd;;;IAGA,WAAW;;IAEX;MACE,gDAAgD;;MAEhD,SAAS;IACX;;IAEA;MACE,YAAY;;MAEZ,gBAAgB;IAClB;;IAEA;MACE,WAAW;;MAEX,eAAe;;MAEf,YAAY;IACd;;IAEA;MACE,sBAAsB;;MAEtB,uBAAuB;IACzB;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,WAAW;;MAEX,eAAe;IACjB;;IAEA;MACE,sBAAsB;;MAEtB,uBAAuB;IACzB;;;IAGA,iBAAiB;;IAEjB;MACE,aAAa;;MAEb,gBAAgB;IAClB;;;IAGA,WAAW;;IAEX;MACE,sBAAsB;;MAEtB,oBAAoB;;MAEpB,SAAS;IACX;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,eAAe;IACjB;;;IAGA,WAAW;;IAEX;MACE,WAAW;;MAEX,YAAY;;MAEZ,YAAY;IACd;;;IAGA,iBAAiB;;IAEjB;MACE,WAAW;;MAEX,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;IAClB;;;IAGA,WAAW;;IAEX;MACE,WAAW;;MAEX,gBAAgB;;MAEhB,kBAAkB;;MAElB,iCAAiC;IACnC;;IAEA;MACE,uBAAuB;;MAEvB,2BAA2B;IAC7B;;;IAGA,eAAe;;IAEf;MACE,sBAAsB;;MAEtB,mBAAmB;;MAEnB,uBAAuB;;MAEvB,SAAS;;MAET,eAAe;IACjB;;IAEA;MACE,WAAW;;MAEX,kBAAkB;;MAElB,0BAA0B;IAC5B;;IAEA;MACE,WAAW;;MAEX,uBAAuB;;MAEvB,cAAc;;MAEd,SAAS;;MAET,eAAe;IACjB;;IAEA;MACE,SAAS;IACX;;IAEA;;;MAGE,0BAA0B;IAC5B;;;IAGA,mBAAmB;;IAEnB;MACE,sBAAsB;;MAEtB,SAAS;;MAET,mBAAmB;IACrB;;IAEA;MACE,uBAAuB;;MAEvB,eAAe;IACjB;EACF;;;EAGA;;;6DAG2D;;EAE3D;;IAEE;MACE,wBAAwB;IAC1B;;;IAGA,WAAW;;IAEX;MACE,aAAa;;MAEb,mBAAmB;IACrB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,YAAY;;MAEZ,eAAe;IACjB;;;IAGA,iBAAiB;;IAEjB;MACE,0BAA0B;;MAE1B,SAAS;IACX;;IAEA;MACE,YAAY;;MAEZ,iBAAiB;IACnB;;IAEA;MACE,WAAW;;MAEX,eAAe;IACjB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,0BAA0B;IAC5B;;;IAGA,YAAY;;IAEZ;MACE,aAAa;;MAEb,kBAAkB;;MAElB,gBAAgB;IAClB;;IAEA;MACE,WAAW;;MAEX,YAAY;IACd;;IAEA;MACE,eAAe;IACjB;;;IAGA,iBAAiB;;IAEjB;MACE,gBAAgB;IAClB;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,yBAAyB;IAC3B;;;IAGA,WAAW;;IAEX;MACE,uBAAuB;;MAEvB,2BAA2B;IAC7B;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,yBAAyB;IAC3B;;;IAGA,WAAW;;IAEX;;MAEE,WAAW;;MAEX,eAAe;;MAEf,YAAY;;MAEZ,cAAc;IAChB;;;IAGA,eAAe;;IAEf;MACE,cAAc;;MAEd,QAAQ;IACV;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,QAAQ;IACV;;IAEA;MACE,QAAQ;IACV;;IAEA;;;MAGE,0BAA0B;IAC5B;EACF;;;EAGA;;;6DAG2D;;EAE3D;;IAEE;MACE,wBAAwB;IAC1B;;;IAGA,WAAW;;IAEX;MACE,YAAY;IACd;;IAEA;MACE,WAAW;;MAEX,eAAe;;MAEf,YAAY;IACd;;IAEA;MACE,sBAAsB;;MAEtB,uBAAuB;IACzB;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,0BAA0B;IAC5B;;;IAGA,YAAY;;IAEZ;MACE,YAAY;IACd;;IAEA;MACE,eAAe;IACjB;;;IAGA,iBAAiB;;IAEjB;MACE,gBAAgB;IAClB;;;IAGA,WAAW;;IAEX;MACE,uBAAuB;;MAEvB,2BAA2B;IAC7B;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,yBAAyB;IAC3B;;;IAGA,WAAW;;IAEX;;MAEE,WAAW;;MAEX,eAAe;;MAEf,YAAY;;MAEZ,cAAc;IAChB;;;IAGA,eAAe;;IAEf;MACE,QAAQ;IACV;;IAEA;MACE,QAAQ;IACV;;IAEA;MACE,QAAQ;IACV;;IAEA;;;MAGE,yBAAyB;IAC3B;EACF;;;EAGA;;6DAE2D;;EAE3D;;IAEE;;MAEE,iCAAiC;IACnC;EACF;;EAEA;EACA,WAAW;EACX,gBAAgB,IAAI,4BAA4B;EAChD,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;;EAElB,mBAAmB,OAAO,kBAAkB;EAC5C,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,gBAAgB;;EAEhB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;;EAEnB,aAAa;EACb,mBAAmB;;EAEnB,kBAAkB;EAClB,iBAAiB;;EAEjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;;EAEd,eAAe;EACf,gBAAgB;EAChB,cAAc;;EAEd,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;;EAEvB,oCAAoC;EACpC,6BAA6B;;EAE7B,2BAA2B;;EAE3B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;;;EAIE,qBAAqB;;AAEvB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,OAAO;EACP,WAAW;EACX,eAAe;EACf,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;;AAGA,UAAU;AACV;;2DAE2D;AAC3D,WAAW,mBAAmB,EAAE,iBAAiB,EAAE;;AAEnD,iBAAiB,uBAAuB,EAAE;AAC1C,eAAe,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAClE,YAAY,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;;AAE/D,eAAe;AACf;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,6EAA6E,EAAE,kBAAkB,EAAE,mBAAmB;AACxH;AACA,mBAAmB,WAAW,EAAE,eAAe,EAAE,gBAAgB,EAAE,SAAS,EAAE,mBAAmB,EAAE;AACnG,oBAAoB,SAAO,EAAE;AAC7B;EACE,2BAA2B,EAAE,oCAAoC;EACjE,2BAA2B,EAAE,uBAAuB,EAAE,6BAA6B;AACrF;AACA,0CAA0C,uBAAuB,EAAE;AACnE;;0CAE0C,wBAAwB,EAAE,eAAe,EAAE;AACrF,oCAAoC,yBAAyB,EAAE,uBAAuB,EAAE;AACxF,+BAA+B,WAAW,EAAE;;AAE5C,gBAAgB;AAChB;EACE,gBAAgB,EAAE,mBAAmB,EAAE,kBAAkB;EACzD,mBAAmB,EAAE,wCAAwC;AAC/D;AACA,iBAAiB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE;;AAEzF,iBAAiB;AACjB,cAAc,aAAa,EAAE,gDAAgD,EAAE,SAAS,EAAE;AAC1F;EACE,kBAAkB,EAAE,iBAAiB,EAAE,mBAAmB;EAC1D,uBAAuB,EAAE,iBAAiB;EAC1C,aAAa,EAAE,sBAAsB;AACvC;AACA;EACE,kBAAkB,EAAE,SAAS,EAAE,WAAW,EAAE,WAAW,EAAE,YAAY;EACrE,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;AACjF;AACA;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,kBAAkB;EACjE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;AAC7D;AACA,sBAAsB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AACtE,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE;AACnE,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,kBAAkB,EAAE;AACvF,iBAAiB,gBAAgB,EAAE,WAAW,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AAC3G,sBAAsB,cAAc,EAAE,YAAY,EAAE,kBAAkB,EAAE;;AAExE,aAAa,cAAc,EAAE;AAC7B,uBAAuB,mBAAmB,EAAE,qBAAqB,EAAE;AACnE,8EAA8E,mBAAmB,EAAE;AACnG,qCAAqC,mBAAmB,EAAE;;AAE1D,uBAAuB,mBAAmB,EAAE,qBAAqB,EAAE;AACnE,kFAAkF,mBAAmB,EAAE;AACvG,uCAAuC,mBAAmB,EAAE;;AAE5D,uBAAuB,mBAAmB,EAAE,qBAAqB,EAAE;AACnE,gFAAgF,mBAAmB,EAAE;AACrG,sCAAsC,mBAAmB,EAAE;;AAE3D,uBAAuB,mBAAmB,EAAE,qBAAqB,EAAE;AACnE,kFAAkF,mBAAmB,EAAE;AACvG,uCAAuC,mBAAmB,EAAE;;AAE5D,0BAA0B;AAC1B,oBAAoB,mBAAmB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;AACvF,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE,mBAAmB,EAAE;AACzH,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE;AAClH,wBAAwB,WAAW,EAAE,YAAY,EAAE;AACnD;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,YAAY,EAAE,YAAY;EACxE,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,eAAe;AAClF;AACA,iBAAiB,WAAW,EAAE,YAAY,EAAE;AAC5C,mBAAmB,YAAY,EAAE,aAAa,EAAE,WAAW,EAAE,eAAe,EAAE,uBAAuB,EAAE;;AAEvG;EACE,gBAAgB,EAAE,mBAAmB,EAAE,kBAAkB;EACzD,wCAAwC;AAC1C;AACA,mBAAmB,gBAAgB,EAAE;AACrC,YAAY,WAAW,EAAE,yBAAyB,EAAE,eAAe,EAAE;AACrE;EACE,mBAAmB,EAAE,WAAW,EAAE,gBAAgB,EAAE,eAAe;EACnE,gBAAgB,EAAE,kBAAkB,EAAE,sBAAsB,EAAE,mBAAmB;AACnF;AACA;EACE,kBAAkB,EAAE,sBAAsB,EAAE,WAAW,EAAE,gBAAgB;EACzE,sBAAsB,EAAE,eAAe;AACzC;AACA,qCAAqC,mBAAmB,EAAE;AAC1D,qCAAqC,mBAAmB,EAAE;AAC1D,iBAAiB,kBAAkB,EAAE;AACrC,iBAAiB,kBAAkB,EAAE;AACrC,iBAAiB,kBAAkB,EAAE;AACrC,wBAAwB,cAAc,EAAE,gBAAgB,EAAE,kBAAkB,CAAC;AAC7E,wBAAwB,cAAc,EAAE,gBAAgB,EAAE,kBAAkB,CAAC;AAC7E,WAAW,2BAA2B,EAAE;AACxC,eAAe,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE,sBAAsB,EAAE;;AAErF,eAAe;AACf,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,gBAAgB,EAAE;AACvG,cAAc,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE;AACzE,YAAY,aAAa,EAAE,QAAQ,EAAE;AACrC;EACE,eAAe,EAAE,YAAY,EAAE,YAAY,EAAE,kBAAkB,EAAE,gBAAgB;EACjF,wCAAwC,EAAE,WAAW,EAAE,eAAe,EAAE,eAAe;AACzF;AACA,0BAA0B,qDAAqD,EAAE,WAAW,EAAE,gBAAgB,EAAE;AAChH,4BAA4B,YAAY,EAAE,mBAAmB,EAAE;;AAE/D,eAAe;AACf,4BAA4B,cAAc,gDAAgD,EAAE,EAAE;AAC9F;EACE,cAAc,0BAA0B,EAAE;EAC1C,iBAAiB,sBAAsB,EAAE,oBAAoB,EAAE,QAAQ,EAAE,aAAa,EAAE;EACxF,WAAW,kBAAkB,EAAE,aAAa,EAAE;EAC9C,qCAAqC,sBAAsB,EAAE,oBAAoB,EAAE,SAAS,EAAE;EAC9F,aAAa,WAAW,EAAE;EAC1B,YAAY,uBAAuB,EAAE;EACrC,YAAY,gBAAgB,EAAE;AAChC;;;AAGA,+DAA+D;;AAE/D,uCAAuC;AACvC;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;yCACyC,mBAAmB,EAAE;AAC9D,qCAAqC,mBAAmB,EAAE;;AAE1D,gCAAgC;AAChC;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;2CAC2C,mBAAmB,EAAE;AAChE,uCAAuC,mBAAmB,EAAE;;AAE5D,iCAAiC;AACjC;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;0CAC0C,mBAAmB,EAAE;AAC/D,sCAAsC,mBAAmB,EAAE;;AAE3D,mCAAmC;AACnC;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;2CAC2C,mBAAmB,EAAE;AAChE,uCAAuC,mBAAmB,EAAE;;AAE5D,8CAA8C;AAC9C,iBAAiB,mBAAmB,EAAE,WAAW,EAAE;;AAEnD,yCAAyC;AACzC,mBAAmB,cAAc,EAAE,gBAAgB,EAAE;AACrD,mBAAmB,cAAc,EAAE;AACnC,sBAAsB,UAAU,EAAE,oCAAoC,EAAE;AACxE,iEAAiE;AACjE,0CAA0C,wBAAwB,EAAE;;;;AAIpE,qCAAqC;AACrC,uCAAuC,cAAc,EAAE;;AAEvD;sBACsB;AACtB,wCAAwC,cAAc,EAAE;;;;AAIxD,iDAAiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA,8CAA8C,cAAc,EAAE;AAC9D;EACE,cAAc;EACd,mBAAmB;EACnB,UAAU;AACZ;AACA,WAAW,eAAe,EAAE,cAAc,EAAE;;AAE5C,iBAAiB;AACjB,yBAAyB,cAAc,EAAE;AACzC,+BAA+B,cAAc,EAAE;AAC/C;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB,IAAI,6BAA6B;AAC1D;;AAEA,wCAAwC,aAAa,EAAE;;;;AAIvD,2EAA2E;;AAE3E,6BAA6B;AAC7B;EACE,WAAW,EAAE,YAAY,EAAE,UAAU,EAAE,iBAAiB;EACxD,YAAY,EAAE,kBAAkB,EAAE,gBAAgB;EAClD,uCAAuC;EACvC,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe;AACrF;AACA,eAAe,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AAC/D,iBAAiB,mBAAmB,EAAE;;AAEtC,qDAAqD;AACrD,oBAAoB,gBAAgB,EAAE;AACtC,qBAAqB,mBAAmB,EAAE,iBAAiB,EAAE;;AAE7D,gBAAgB;AAChB,uBAAuB,cAAc,EAAE,gBAAgB,EAAE;AACzD,uBAAuB,cAAc,EAAE,gBAAgB,EAAE;;AAEzD,kBAAkB;AAClB;EACE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;EAClE,eAAe,EAAE,YAAY,EAAE,eAAe;EAC9C,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE,WAAW;AACrE;AACA,qBAAqB,mBAAmB,EAAE;AAC1C,qBAAqB,mBAAmB,EAAE;;AAE1C,6DAA6D;AAC7D;EACE,gBAAgB,EAAE,OAAO,EAAE,WAAW;EACtC,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EACzE,gBAAgB,EAAE,WAAW,EAAE,eAAe;AAChD;;AAEA,wBAAwB;AACxB,0BAA0B,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAE7E,WAAW;AACX;EACE,yBAAyB,eAAe,EAAE;AAC5C;;;AAGA,gBAAgB;AAChB;EACE,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,sBAAsB,MAAM,+BAA+B;EAC3D,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mCAAmC,mBAAmB,EAAE;;AAExD,gEAAgE;AAChE;EACE,WAAW;EACX,YAAY;AACd;;;AAGA,uCAAuC,mBAAmB,EAAE;AAC5D,uCAAuC,mBAAmB,EAAE;AAC5D,uCAAuC,mBAAmB,EAAE;AAC5D,uCAAuC,mBAAmB,EAAE;;AAE5D,mEAAmE;AACnE;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,gCAAgC;EAChC,sBAAsB;AACxB;AACA,wCAAwC,cAAc,EAAE;AACxD,wCAAwC,cAAc,EAAE;AACxD,wCAAwC,cAAc,EAAE;AACxD,wCAAwC,cAAc,EAAE;;AAExD,kFAAkF;AAClF,uBAAuB,mBAAmB,EAAE,2BAA2B,EAAE;AACzE,uBAAuB,mBAAmB,EAAE,2BAA2B,EAAE;AACzE,uBAAuB,mBAAmB,EAAE,2BAA2B,EAAE;AACzE,uBAAuB,mBAAmB,EAAE,2BAA2B,EAAE;;AAEzE;;2DAE2D;;AAE3D,qCAAqC;AACrC;EACE,WAAW;EACX,yBAAyB,OAAO,+BAA+B;EAC/D,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,gDAAgD;EAChD,gCAAgC;AAClC;AACA,gCAAgC,eAAe,EAAE;;AAEjD,sCAAsC;AACtC;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,+BAA+B;EAC/B,gCAAgC;EAChC,sBAAsB;AACxB;AACA,gCAAgC,eAAe,EAAE;AACjD,mCAAmC,gBAAgB,EAAE;;AAErD,eAAe;AACf,qCAAqC,mBAAmB,EAAE;AAC1D,qCAAqC,mBAAmB,EAAE;AAC1D,2BAA2B,mBAAmB,EAAE;;AAEhD,8BAA8B;AAC9B,iBAAiB,kBAAkB,EAAE;AACrC,iBAAiB,kBAAkB,EAAE,kBAAkB,EAAE;AACzD,iBAAiB,kBAAkB,EAAE,mBAAmB,EAAE;AAC1D,wBAAwB,cAAc,EAAE,gBAAgB,EAAE;AAC1D,wBAAwB,cAAc,EAAE,gBAAgB,EAAE;AAC1D,wBAAwB,cAAc,EAAE,gBAAgB,EAAE;AAC1D,wBAAwB,cAAc,EAAE,gBAAgB,EAAE;;AAE1D,kCAAkC;AAClC,WAAW,2BAA2B,EAAE;AACxC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;AACA,wBAAwB;AACxB;;EAEE,6BAA6B;AAC/B;;;;;;AAMA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,yBAAyB;AAC3B","sourcesContent":["  /* =========================================================\r\n    DASHBOARD - COMPLETE RESPONSIVE CSS\r\n  ========================================================= */\r\n\r\n\r\n  /* =========================================================\r\n    GLOBAL\r\n  ========================================================= */\r\n\r\n  * {\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .no-scrollbar {\r\n    background: #ffffff !important;\r\n  }\r\n\r\n  .dashboard-page {\r\n    width: 100%;\r\n    min-height: 100%;\r\n    background: #ffffff;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .dashboard-main-width {\r\n    width: min(980px, calc(100% - 30px));\r\n    max-width: 980px;\r\n    margin: 0 auto;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n\r\n  /* =========================================================\r\n    SCHEME CARD\r\n  ========================================================= */\r\n\r\n  .scheme-card {\r\n    width: 100%;\r\n    max-width: 940px;\r\n    min-height: 82px;\r\n\r\n    margin: 0 auto 18px;\r\n    padding: 10px 16px;\r\n\r\n    background: #edf5fc;\r\n    border: 1px solid #b7d9ff;\r\n    border-radius: 10px;\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .scheme-label {\r\n    flex-shrink: 0;\r\n\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n\r\n    color: #111111;\r\n\r\n    margin-right: 10px;\r\n\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .scheme-select {\r\n    width: 753px;\r\n    max-width: calc(100% - 100px);\r\n    height: 38px;\r\n\r\n    padding: 6px 12px;\r\n\r\n    border: 1px solid #d2d2d2;\r\n    border-radius: 5px;\r\n\r\n    background: #ffffff;\r\n\r\n    font-size: 12px;\r\n    color: #222222;\r\n\r\n    outline: none;\r\n\r\n    box-sizing: border-box;\r\n  }\r\n\r\n\r\n  /* =========================================================\r\n    METRIC CARDS ROW\r\n  ========================================================= */\r\n\r\n  .metric-cards-row {\r\n    width: 100%;\r\n    max-width: 980px;\r\n\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(0, 1fr));\r\n\r\n    gap: 20px;\r\n\r\n    margin: 0 auto;\r\n\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .metric-card-col {\r\n    width: 100%;\r\n    min-width: 0;\r\n  background-color: #f3f8fd;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n\r\n  /* =========================================================\r\n    METRIC CARD\r\n  ========================================================= */\r\n\r\n  .metric-card {\r\n    width: 100%;\r\n    height: 90px;\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n\r\n    padding: 10px 10px;\r\n\r\n    border-radius: 12px;\r\n\r\n    box-sizing: border-box;\r\n\r\n    overflow: hidden;\r\n\r\n    box-shadow: none;\r\n\r\n    transition: transform 0.2s ease;\r\n  }\r\n\r\n  .metric-card:hover {\r\n    transform: translateY(-2px);\r\n  }\r\n\r\n\r\n  /* Individual colors */\r\n\r\n  .metric-card-col:nth-child(1) .metric-card {\r\n    border: 0.8px solid #63a9ff;\r\n    background: #f3f8fd;\r\n  }\r\n\r\n  .metric-card-col:nth-child(2) .metric-card {\r\n    border: 0.8px solid #9a91ff;\r\n    background: #f7f8fc;\r\n  }\r\n\r\n  .metric-card-col:nth-child(3) .metric-card {\r\n    border: 0.8px solid #65c879;\r\n    background: #f1fbf4;\r\n  }\r\n\r\n  .metric-card-col:nth-child(4) .metric-card {\r\n    border: 0.8px solid #ff9b4a;\r\n    background: #fcf5e8;\r\n  }\r\n\r\n\r\n  /* =========================================================\r\n    METRIC ICON\r\n  ========================================================= */\r\n\r\n  .metric-icon {\r\n    width: 40px;\r\n    min-width: 40px;\r\n    height: 40px;\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  .metric-icon img {\r\n    width: 40px !important;\r\n    height: 40px !important;\r\n\r\n    object-fit: contain;\r\n  }\r\n\r\n\r\n  /* =========================================================\r\n    METRIC CONTENT\r\n  ========================================================= */\r\n\r\n  .metric-content {\r\n    flex: 1;\r\n    min-width: 0;\r\n\r\n    margin-left: 8px;\r\n    margin-right: 4px;\r\n\r\n    overflow: hidden;\r\n  }\r\n\r\n  .metric-label {\r\n    font-size: 13px !important;\r\n    font-weight: 550;\r\n\r\n    color: #3f4344;\r\n\r\n    line-height: 1.2;\r\n\r\n    margin-bottom: 3px;\r\n\r\n    text-decoration: none;\r\n\r\n    white-space: nowrap;\r\n\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    \r\n  }\r\n\r\n  .metric-value {\r\n    font-size: 12px !important;\r\n    font-weight: 800;\r\n\r\n    color: #111111;\r\n\r\n    white-space: nowrap;\r\n\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n\r\n\r\n  /* =========================================================\r\n    METRIC ARROW\r\n  ========================================================= */\r\n\r\n  .metric-arrow {\r\n    width: 24px;\r\n    min-width: 24px;\r\n    height: 24px;\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  .metric-arrow-img {\r\n    width: 23px !important;\r\n    height: 23px !important;\r\n\r\n    object-fit: contain;\r\n\r\n    cursor: pointer;\r\n  }\r\n\r\n\r\n  /* =========================================================\r\n    PROJECT DETAILS CARD\r\n  ========================================================= */\r\n\r\n  .project-details-card {\r\n    width: 100%;\r\n    max-width: 940px;\r\n\r\n    margin: 16px auto 10px;\r\n    padding: 16px;\r\n\r\n    background: #ffffff;\r\n\r\n    border-radius: 12px;\r\n\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\r\n\r\n    display: flex;\r\n    flex-direction: column;\r\n\r\n    box-sizing: border-box;\r\n\r\n    overflow: hidden;\r\n  }\r\n\r\n\r\n  /* =========================================================\r\n    PROJECT HEADER\r\n  ========================================================= */\r\n\r\n  .project-header {\r\n    width: 100%;\r\n\r\n    min-height: 32px;\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n\r\n    gap: 15px;\r\n\r\n    margin-bottom: 14px;\r\n\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .first-header {\r\n    min-width: 0;\r\n\r\n    display: flex;\r\n    align-items: center;\r\n\r\n    gap: 7px;\r\n  }\r\n\r\n  .first-header img {\r\n    width: 22px;\r\n    height: 22px;\r\n\r\n    margin-bottom: 0;\r\n\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  .project-title {\r\n    min-width: 0;\r\n\r\n    margin: 0;\r\n\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n\r\n    color: #111111;\r\n\r\n    white-space: nowrap;\r\nmargin-top:0px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n\r\n\r\n  /* =========================================================\r\n    SEARCH\r\n  ========================================================= */\r\n\r\n  .search-container {\r\n    width: 272px;\r\n    min-width: 200px;\r\n    height: 34px;\r\n\r\n    display: flex;\r\n    align-items: center;\r\n\r\n    flex-shrink: 0;\r\n\r\n    background: #ffffff;\r\n\r\n    border: 1px solid #b9c7dc;\r\n    border-radius: 6px;\r\n\r\n    padding: 0 9px;\r\n\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .search-input {\r\n    width: 100%;\r\n    min-width: 0;\r\n\r\n    border: none;\r\n\r\n    background: transparent;\r\n\r\n    outline: none;\r\n\r\n    padding: 4px 5px;\r\n\r\n    font-size: 12px;\r\n\r\n    color: #333333;\r\n  }\r\n\r\n  .search-input::placeholder {\r\n    color: #8b9bb7;\r\n\r\n    font-weight: 600;\r\n  }\r\n\r\n  .search-icon {\r\n    width: 17px;\r\n    height: 17px;\r\n\r\n    margin-right: 6px;\r\n\r\n    flex-shrink: 0;\r\n\r\n    opacity: 1;\r\n  }\r\n\r\n\r\n  /* =========================================================\r\n    NORMAL TABLE WRAPPER\r\n  ========================================================= */\r\n\r\n  .table-wrapper {\r\n    width: 100%;\r\n    max-width: 100%;\r\n\r\n    overflow-x: auto;\r\n    overflow-y: auto;\r\n\r\n    background: #ffffff;\r\n\r\n    border-radius: 6px;\r\n\r\n    position: relative;\r\n\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .table-wrapper::-webkit-scrollbar {\r\n    height: 6px;\r\n    width: 6px;\r\n  }\r\n\r\n  .table-wrapper::-webkit-scrollbar-track {\r\n    background: #f5f7fa;\r\n  }\r\n\r\n  .table-wrapper::-webkit-scrollbar-thumb {\r\n    background: #cbd5e1;\r\n    border-radius: 10px;\r\n  }\r\n\r\n\r\n  /* =========================================================\r\n    MAIN PROJECT TABLE\r\n  ========================================================= */\r\n\r\n  .project-table {\r\n    width: 100%;\r\n\r\n    border-collapse: collapse;\r\n\r\n    table-layout: fixed;\r\n\r\n    background: #ffffff;\r\n\r\n    font-family: \"Inter\", sans-serif;\r\n\r\n    margin: 0;\r\n  }\r\n\r\n\r\n  /* Header */\r\n\r\n  .project-table thead {\r\n    background: #e4ebfd;\r\n  }\r\n\r\n  .project-table thead tr {\r\n    height: 34px;\r\n\r\n    background: #e4eaff;\r\n  }\r\n\r\n  .project-table thead th {\r\n    height: 34px;\r\n\r\n    padding: 7px 6px;\r\n\r\n    background: #e4eaff !important;\r\n\r\n    color: #222222 !important;\r\n\r\n    border: 1px solid #d8deed;\r\n\r\n    font-size: 14px;\r\n\r\n    font-weight: 600;\r\n\r\n    text-align: center;\r\n\r\n    vertical-align: middle;\r\n\r\n    white-space: nowrap;\r\n\r\n    box-sizing: border-box;\r\n\r\n    position: sticky;\r\n\r\n    top: 0;\r\n\r\n    z-index: 10;\r\n  }\r\n\r\n\r\n  /* Body */\r\n\r\n  .project-table tbody tr {\r\n    height: 38px;\r\n  }\r\n\r\n  .project-table tbody tr:nth-child(odd) {\r\n    background: #fdfdfd;\r\n  }\r\n\r\n  .project-table tbody tr:nth-child(even) {\r\n    background: #f8f8fb;\r\n  }\r\n\r\n  .project-table tbody td {\r\n    height: 38px;\r\n\r\n    padding: 7px;\r\n\r\n    border: 1px solid #e2e6ee;\r\n\r\n    color: #171717;\r\n\r\n    font-size: 13px;\r\n\r\n    font-weight: 500;\r\n\r\n    line-height: 1.25;\r\n\r\n    text-align: center;\r\n\r\n    vertical-align: middle;\r\n\r\n    box-sizing: border-box;\r\n\r\n    overflow: visible;\r\n  }\r\n\r\n\r\n  /* Project name */\r\n\r\n  .project-table tbody td:nth-child(2) {\r\n    text-align: left;\r\n\r\n    padding-left: 12px;\r\n\r\n    white-space: normal;\r\n\r\n    word-break: normal;\r\n\r\n    overflow-wrap: break-word;\r\n  }\r\n\r\n\r\n  /* Agency */\r\n\r\n  .project-table tbody td:nth-child(3) {\r\n    text-align: center;\r\n\r\n    white-space: nowrap;\r\n  }\r\n\r\n\r\n  /* Approved cost */\r\n\r\n  .project-table tbody td.approved-cost {\r\n    color: #009b63;\r\n\r\n    font-weight: 700;\r\n\r\n    text-align: center;\r\n\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .project-table .approved-icon {\r\n    width: 14px;\r\n    height: 14px;\r\n\r\n    vertical-align: middle;\r\n\r\n    margin-right: 4px;\r\n  }\r\n\r\n\r\n  /* Demand */\r\n\r\n  .project-table tbody td.demand-amount {\r\n    color: #111111;\r\n\r\n    font-weight: 500;\r\n\r\n    text-align: center;\r\n  }\r\n\r\n\r\n  /* Limit */\r\n\r\n  .project-table tbody td.limit-amount {\r\n    color: #1687e8;\r\n\r\n    font-weight: 600;\r\n\r\n    text-align: center;\r\n  }\r\n\r\n\r\n  /* Balance */\r\n\r\n  .project-table tbody td.balance-positive {\r\n    color: #008f5a;\r\n\r\n    font-weight: 600;\r\n  }\r\n\r\n  .project-table tbody td.balance-negative {\r\n    color: #e1261c;\r\n\r\n    font-weight: 600;\r\n  }\r\n\r\n\r\n  /* =========================================================\r\n    PROJECT TABLE COLUMN WIDTHS\r\n  ========================================================= */\r\n\r\n  .project-table.six-column th:nth-child(1),\r\n  .project-table.six-column td:nth-child(1) {\r\n    width: 8%;\r\n  }\r\n\r\n  .project-table.six-column th:nth-child(2),\r\n  .project-table.six-column td:nth-child(2) {\r\n    width: 23%;\r\n  }\r\n\r\n  .project-table.six-column th:nth-child(3),\r\n  .project-table.six-column td:nth-child(3) {\r\n    width: 20%;\r\n  }\r\n\r\n  .project-table.six-column th:nth-child(4),\r\n  .project-table.six-column td:nth-child(4) {\r\n    width: 18%;\r\n  }\r\n\r\n  .project-table.six-column th:nth-child(5),\r\n  .project-table.six-column td:nth-child(5) {\r\n    width: 15%;\r\n  }\r\n\r\n  .project-table.six-column th:nth-child(6),\r\n  .project-table.six-column td:nth-child(6) {\r\n    width: 16%;\r\n  }\r\n\r\n\r\n  /* 7 columns */\r\n\r\n  .project-table.seven-column th:nth-child(1),\r\n  .project-table.seven-column td:nth-child(1) {\r\n    width: 7%;\r\n  }\r\n\r\n  .project-table.seven-column th:nth-child(2),\r\n  .project-table.seven-column td:nth-child(2) {\r\n    width: 19%;\r\n  }\r\n\r\n  .project-table.seven-column th:nth-child(3),\r\n  .project-table.seven-column td:nth-child(3) {\r\n    width: 17%;\r\n  }\r\n\r\n  .project-table.seven-column th:nth-child(4),\r\n  .project-table.seven-column td:nth-child(4) {\r\n    width: 17%;\r\n  }\r\n\r\n  .project-table.seven-column th:nth-child(5),\r\n  .project-table.seven-column td:nth-child(5) {\r\n    width: 13%;\r\n  }\r\n\r\n  .project-table.seven-column th:nth-child(6),\r\n  .project-table.seven-column td:nth-child(6) {\r\n    width: 14%;\r\n  }\r\n\r\n  .project-table.seven-column th:nth-child(7),\r\n  .project-table.seven-column td:nth-child(7) {\r\n    width: 13%;\r\n  }\r\n\r\n\r\n  /* No records */\r\n\r\n  .project-table .no-records {\r\n    text-align: center !important;\r\n\r\n    padding: 14px !important;\r\n\r\n    color: #777777;\r\n\r\n    font-size: 12px;\r\n  }\r\n\r\n  /* =========================================================\r\n    DEMAND AGAINST LIABILITY\r\n    SAME STRUCTURE AS PROJECT DETAILS\r\n  ========================================================= */\r\n\r\n  .demand-liability-table-wrapper {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    box-sizing: border-box;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .demand-liability-scroll {\r\n    width: 100%;\r\n    max-width: 100%;\r\n\r\n    overflow-x: auto;\r\n    overflow-y: auto;\r\n\r\n    background: #ffffff;\r\n    border-radius: 6px;\r\n\r\n    position: relative;\r\n    box-sizing: border-box;\r\n\r\n    -webkit-overflow-scrolling: touch;\r\n  }\r\n\r\n  .demand-liability-scroll::-webkit-scrollbar {\r\n    width: 6px;\r\n    height: 6px;\r\n  }\r\n\r\n  .demand-liability-scroll::-webkit-scrollbar-track {\r\n    background: #f5f7fa;\r\n  }\r\n\r\n  .demand-liability-scroll::-webkit-scrollbar-thumb {\r\n    background: #cbd5e1;\r\n    border-radius: 10px;\r\n  }\r\n\r\n\r\n     .demand-liability-table {\r\n  width: 100% !important;\r\n  min-width: 0 !important;\r\n  border-collapse: collapse;\r\n  table-layout: fixed;\r\n}\r\n  \r\n\r\n\r\n  /* =========================================================\r\n    DEMAND TABLE COLUMN WIDTHS\r\n  ========================================================= */\r\n\r\n  .demand-liability-table th:nth-child(1),\r\n  .demand-liability-table td:nth-child(1) {\r\n    width: 65px;\r\n  }\r\n\r\n  .demand-liability-table th:nth-child(2),\r\n  .demand-liability-table td:nth-child(2) {\r\n    width: 190px;\r\n  }\r\n\r\n  .demand-liability-table th:nth-child(3),\r\n  .demand-liability-table td:nth-child(3) {\r\n    width: 110px;\r\n  }\r\n\r\n  .demand-liability-table th:nth-child(4),\r\n  .demand-liability-table td:nth-child(4) {\r\n    width: 115px;\r\n  }\r\n\r\n  .demand-liability-table th:nth-child(5),\r\n  .demand-liability-table td:nth-child(5) {\r\n    width: 125px;\r\n  }\r\n\r\n  .demand-liability-table th:nth-child(6),\r\n  .demand-liability-table td:nth-child(6) {\r\n    width: 125px;\r\n  }\r\n\r\n  .demand-liability-table th:nth-child(7),\r\n  .demand-liability-table td:nth-child(7) {\r\n    width: 125px;\r\n  }\r\n\r\n  .demand-liability-table th:nth-child(8),\r\n  .demand-liability-table td:nth-child(8) {\r\n    width: 130px;\r\n  }\r\n\r\n  .demand-liability-table th:nth-child(9),\r\n  .demand-liability-table td:nth-child(9) {\r\n    width: 115px;\r\n  }\r\n\r\n\r\n  /* =========================================================\r\n    HEADER - SAME AS PROJECT DETAILS\r\n  ========================================================= */\r\n\r\n  .demand-liability-table thead {\r\n    background: #e4eaff;\r\n  }\r\n\r\n  .demand-liability-table thead tr {\r\n    height: 34px;\r\n    background: #e4eaff;\r\n  }\r\n\r\n  .demand-liability-table thead th {\r\n    height: 34px;\r\n\r\n    padding: 7px 6px !important;\r\n\r\n    background: #e4eaff !important;\r\n\r\n    color: #222222 !important;\r\n\r\n    border: 1px solid #d8deed !important;\r\n\r\n    font-size: 14px !important;\r\n\r\n    font-weight: 600 !important;\r\n\r\n    text-align: center !important;\r\n\r\n    vertical-align: middle;\r\n\r\n    white-space: nowrap;\r\n\r\n    line-height: 1.2;\r\n\r\n    box-sizing: border-box;\r\n\r\n    position: sticky;\r\n\r\n    top: 0;\r\n\r\n    z-index: 10;\r\n  }\r\n\r\n\r\n  /* =========================================================\r\n    BODY - SAME AS PROJECT DETAILS\r\n  ========================================================= */\r\n\r\n  .demand-liability-table tbody tr {\r\n    height: 38px;\r\n  }\r\n\r\n  .demand-liability-table tbody tr:nth-child(odd) {\r\n    background: #ffffff;\r\n  }\r\n\r\n  .demand-liability-table tbody tr:nth-child(even) {\r\n    background: #f5f8fc;\r\n  }\r\n\r\n  .demand-liability-table tbody td {\r\n    height: 38px;\r\n\r\n    padding: 7px;\r\n\r\n    border: 1px solid #e2e6ee !important;\r\n\r\n    color: #171717;\r\n\r\n    font-size: 13px !important;\r\n\r\n    font-weight: 500;\r\n\r\n    line-height: 1.25;\r\n\r\n    text-align: center;\r\n\r\n    vertical-align: middle;\r\n\r\n    white-space: nowrap;\r\n\r\n    box-sizing: border-box;\r\n  }\r\n\r\n\r\n  /* Project name */\r\n\r\n  .demand-liability-table tbody td:nth-child(2) {\r\n    text-align: left;\r\n\r\n    padding-left: 12px;\r\n\r\n    white-space: normal;\r\n\r\n    word-break: normal;\r\n\r\n    overflow-wrap: break-word;\r\n  }\r\n\r\n\r\n  /* =========================================================\r\n    AMOUNT COLORS\r\n  ========================================================= */\r\n\r\n  .demand-liability-table .red-amount {\r\n    color: #e1261c !important;\r\n    font-weight: 600;\r\n  }\r\n\r\n  .demand-liability-table .positive-balance {\r\n    color: #008f5a !important;\r\n    font-weight: 600;\r\n  }\r\n\r\n  .demand-liability-table .negative-balance {\r\n    color: #e1261c !important;\r\n    font-weight: 600;\r\n  }\r\n\r\n\r\n  /* Demand header */\r\n\r\n  .demand-liability-table thead th {\r\n    height: 34px;\r\n\r\n    padding: 7px 6px !important;\r\n\r\n    background: #e3eaff !important;\r\n\r\n    color: #202020 !important;\r\n\r\n    border: 1px solid #d7ddef !important;\r\n\r\n    font-size: 14px !important;\r\n\r\n    font-weight: 600 !important;\r\n\r\n    text-align: center !important;\r\n\r\n    vertical-align: middle;\r\n\r\n    white-space: normal;\r\n\r\n    line-height: 1.2;\r\n  }\r\n\r\n\r\n  /* Demand body */\r\n\r\n  .demand-liability-table tbody tr {\r\n    height: 38px;\r\n  }\r\n\r\n  .demand-liability-table tbody tr:nth-child(odd) {\r\n    background: #ffffff;\r\n  }\r\n\r\n  .demand-liability-table tbody tr:nth-child(even) {\r\n    background: #f3f8fd;\r\n  }\r\n\r\n  .demand-liability-table tbody td {\r\n    height: 38px;\r\n\r\n    padding: 7px 8px !important;\r\n\r\n    border: 1px solid #e2e6ee !important;\r\n\r\n    font-size: 12px !important;\r\n\r\n    font-weight: 500;\r\n\r\n    color: #111111;\r\n\r\n    text-align: center;\r\n\r\n    vertical-align: middle;\r\n\r\n    white-space: nowrap;\r\n\r\n    box-sizing: border-box;\r\n  }\r\n\r\n\r\n  /* Project name */\r\n\r\n  .demand-project-name {\r\n    text-align: left !important;\r\n\r\n    padding-left: 14px !important;\r\n\r\n    white-space: normal !important;\r\n\r\n    line-height: 1.25;\r\n  }\r\n\r\n\r\n  /* Red amounts */\r\n\r\n  .demand-liability-table .red-amount {\r\n    color: #e11d23 !important;\r\n\r\n    font-weight: 500;\r\n  }\r\n\r\n\r\n  /* =========================================================\r\n    STATUS\r\n  ========================================================= */\r\n\r\n  .demand-liability-table td:last-child {\r\n    text-align: center;\r\n\r\n    white-space: nowrap;\r\n\r\n    overflow: visible;\r\n  }\r\n\r\n  .demand-liability-table .status-pending {\r\n    width: 90px;\r\n\r\n    min-width: 90px;\r\n\r\n    height: 28px;\r\n\r\n    margin: 0 auto;\r\n\r\n    padding: 0 8px;\r\n\r\n    background: #e11d23 !important;\r\n\r\n    color: #ffffff !important;\r\n\r\n    border-radius: 16px;\r\n\r\n    display: inline-flex;\r\n\r\n    align-items: center;\r\n\r\n    justify-content: center;\r\n\r\n    gap: 4px;\r\n\r\n    font-size: 12px;\r\n\r\n    font-weight: 600;\r\n\r\n    white-space: nowrap;\r\n\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .demand-liability-table .status-approved {\r\n    width: 90px;\r\n\r\n    min-width: 90px;\r\n\r\n    height: 28px;\r\n\r\n    margin: 0 auto;\r\n\r\n    padding: 0 8px;\r\n\r\n    border-radius: 16px;\r\n\r\n    display: inline-flex;\r\n\r\n    align-items: center;\r\n\r\n    justify-content: center;\r\n\r\n    gap: 4px;\r\n\r\n    font-size: 12px;\r\n\r\n    font-weight: 600;\r\n\r\n    white-space: nowrap;\r\n\r\n    box-sizing: border-box;\r\n  }\r\n\r\n\r\n  /* =========================================================\r\n    PAGINATION\r\n  ========================================================= */\r\n\r\n  .demand-pagination {\r\n    width: 100%;\r\n    max-width: 100%;\r\n\r\n    min-height: 42px;\r\n\r\n    display: flex;\r\n\r\n    align-items: center;\r\n\r\n    justify-content: space-between;\r\n\r\n    gap: 15px;\r\n\r\n    margin-top: 12px;\r\n\r\n    padding: 8px 4px;\r\n\r\n    background: #ffffff;\r\n\r\n    box-sizing: border-box;\r\n\r\n    overflow: visible !important;\r\n  }\r\n\r\n  .demand-showing-text {\r\n    flex-shrink: 0;\r\n\r\n    margin: 0;\r\n\r\n    font-size: 12px !important;\r\n\r\n    font-weight: 500;\r\n\r\n    color: #333333;\r\n\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .demand-pagination-controls {\r\n    display: flex;\r\n\r\n    align-items: center;\r\n\r\n    justify-content: flex-end;\r\n\r\n    flex-wrap: nowrap;\r\n\r\n    gap: 18px;\r\n\r\n    margin-left: auto;\r\n  }\r\n\r\n  .demand-page-btn {\r\n    border: none;\r\n\r\n    background: transparent;\r\n\r\n    color: #2ea4e7;\r\n\r\n    font-size: 12px !important;\r\n\r\n    font-weight: 500;\r\n\r\n    padding: 0;\r\n\r\n    cursor: pointer;\r\n\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .demand-page-btn:hover:not(:disabled) {\r\n    color: #147fc0;\r\n  }\r\n\r\n  .demand-page-btn:disabled,\r\n  .demand-page-btn.disabled {\r\n    color: #aaaaaa;\r\n\r\n    cursor: not-allowed;\r\n\r\n    opacity: 0.6;\r\n  }\r\n\r\n  .demand-page-numbers {\r\n    display: flex;\r\n\r\n    align-items: center;\r\n\r\n    gap: 14px;\r\n  }\r\n\r\n  .demand-page-number {\r\n    border: none;\r\n\r\n    background: transparent;\r\n\r\n    color: #444444;\r\n\r\n    font-size: 12px !important;\r\n\r\n    font-weight: 500;\r\n\r\n    padding: 0;\r\n\r\n    min-width: 12px;\r\n\r\n    cursor: pointer;\r\n  }\r\n\r\n  .demand-page-number:hover {\r\n    color: #2ea4e7;\r\n  }\r\n\r\n  .demand-page-number.active {\r\n    color: #2ea4e7;\r\n\r\n    font-size: 12px !important;\r\n\r\n    font-weight: 600;\r\n\r\n    text-decoration: underline;\r\n  }\r\n\r\n  .demand-page-dots {\r\n    color: #777777;\r\n\r\n    font-size: 12px !important;\r\n  }\r\n\r\n\r\n  /* =========================================================\r\n    OLD PAGINATION SUPPORT\r\n  ========================================================= */\r\n\r\n  .pagination-footer {\r\n    display: flex;\r\n\r\n    align-items: center;\r\n\r\n    justify-content: space-between;\r\n\r\n    padding-top: 10px;\r\n\r\n    background: #ffffff;\r\n\r\n    box-sizing: border-box;\r\n\r\n    width: 100%;\r\n  }\r\n\r\n  .pagination-footer p {\r\n    margin: 0;\r\n\r\n    font-size: 12px;\r\n  }\r\n\r\n  .pagination-controls {\r\n    display: flex;\r\n\r\n    align-items: center;\r\n\r\n    gap: 14px;\r\n  }\r\n\r\n  .pagination-btn {\r\n    background: transparent;\r\n\r\n    color: #777777;\r\n\r\n    border: none;\r\n\r\n    cursor: pointer;\r\n\r\n    font-size: 12px;\r\n\r\n    padding: 0;\r\n  }\r\n\r\n  .pagination-btn-active {\r\n    background: transparent;\r\n\r\n    color: #2ea4e7;\r\n\r\n    border: none;\r\n\r\n    font-size: 12px;\r\n\r\n    font-weight: 600;\r\n\r\n    text-decoration: underline;\r\n  }\r\n\r\n\r\n  /* =========================================================\r\n    DESKTOP\r\n    > 1200px\r\n  ========================================================= */\r\n\r\n  @media (min-width: 1201px) {\r\n\r\n    .dashboard-main-width {\r\n      width: 940px;\r\n    }\r\n\r\n    .metric-cards-row {\r\n      width: 940px;\r\n\r\n      grid-template-columns: repeat(4, minmax(0, 1fr));\r\n\r\n      gap: 20px;\r\n    }\r\n\r\n    .project-details-card {\r\n      width: 940px;\r\n    }\r\n\r\n    .scheme-card {\r\n      width: 940px;\r\n    }\r\n  }\r\n\r\n\r\n  /* =========================================================\r\n    LAPTOP\r\n    993px - 1200px\r\n  ========================================================= */\r\n\r\n  @media (max-width: 1200px) {\r\n\r\n    .dashboard-main-width {\r\n      width: calc(100% - 30px);\r\n\r\n      max-width: 940px;\r\n    }\r\n\r\n    .scheme-card {\r\n      width: 100%;\r\n    }\r\n\r\n    .scheme-select {\r\n      width: min(753px, calc(100% - 110px));\r\n    }\r\n\r\n    .metric-cards-row {\r\n      width: 100%;\r\n\r\n      gap: 14px;\r\n    }\r\n\r\n    .project-details-card {\r\n      width: 100%;\r\n    }\r\n\r\n    .project-header {\r\n      gap: 12px;\r\n    }\r\n\r\n    .search-container {\r\n      width: 240px;\r\n\r\n      min-width: 200px;\r\n    }\r\n  }\r\n\r\n\r\n  /* =========================================================\r\n    TABLET\r\n    769px - 992px\r\n  ========================================================= */\r\n\r\n  @media (max-width: 992px) {\r\n\r\n    .dashboard-main-width {\r\n      width: calc(100% - 24px);\r\n    }\r\n\r\n\r\n    /* Scheme */\r\n\r\n    .scheme-card {\r\n      min-height: 78px;\r\n\r\n      padding: 10px 14px;\r\n    }\r\n\r\n    .scheme-select {\r\n      flex: 1;\r\n\r\n      width: auto;\r\n\r\n      max-width: none;\r\n    }\r\n\r\n\r\n    /* Cards */\r\n\r\n    .metric-cards-row {\r\n      grid-template-columns: repeat(2, minmax(0, 1fr));\r\n\r\n      gap: 14px;\r\n    }\r\n\r\n    .metric-card {\r\n      height: 80px;\r\n    }\r\n\r\n\r\n    /* Project */\r\n\r\n    .project-details-card {\r\n      padding: 14px;\r\n    }\r\n\r\n\r\n    /* Header */\r\n\r\n    .project-header {\r\n      gap: 10px;\r\n    }\r\n\r\n    .search-container {\r\n      width: 220px;\r\n\r\n      min-width: 180px;\r\n    }\r\n\r\n\r\n    /* Normal table */\r\n\r\n    .table-wrapper {\r\n      overflow-x: auto;\r\n    }\r\n\r\n    .project-table {\r\n      min-width: 750px;\r\n    }\r\n\r\n\r\n    /* Demand table */\r\n\r\n    .demand-liability-table {\r\n      width: 1000px !important;\r\n\r\n      min-width: 1000px !important;\r\n    }\r\n  }\r\n\r\n\r\n  /* =========================================================\r\n    MOBILE TABLET\r\n    577px - 768px\r\n  ========================================================= */\r\n\r\n  @media (max-width: 768px) {\r\n\r\n    .dashboard-main-width {\r\n      width: calc(100% - 20px);\r\n    }\r\n\r\n\r\n    /* Scheme */\r\n\r\n    .scheme-card {\r\n      min-height: auto;\r\n\r\n      flex-direction: column;\r\n\r\n      align-items: stretch;\r\n\r\n      justify-content: center;\r\n\r\n      gap: 7px;\r\n\r\n      padding: 12px;\r\n    }\r\n\r\n    .scheme-label {\r\n      margin-right: 0;\r\n  font-weight: 400;\r\n      font-size: 11px;\r\n    }\r\n\r\n    .scheme-select {\r\n      width: 100%;\r\n\r\n      max-width: none;\r\n\r\n      height: 36px;\r\n    }\r\n\r\n\r\n    /* Metric */\r\n\r\n    .metric-cards-row {\r\n      grid-template-columns: repeat(2, minmax(0, 1fr));\r\n\r\n      gap: 12px;\r\n    }\r\n\r\n    .metric-card {\r\n      height: 78px;\r\n\r\n      padding: 7px 8px;\r\n    }\r\n\r\n    .metric-icon {\r\n      width: 36px;\r\n\r\n      min-width: 36px;\r\n\r\n      height: 36px;\r\n    }\r\n\r\n    .metric-icon img {\r\n      width: 36px !important;\r\n\r\n      height: 36px !important;\r\n    }\r\n\r\n    .metric-label {\r\n      font-size: 10px !important;\r\n    }\r\n\r\n    .metric-value {\r\n      font-size: 11px !important;\r\n    }\r\n\r\n    .metric-arrow {\r\n      width: 22px;\r\n\r\n      min-width: 22px;\r\n    }\r\n\r\n    .metric-arrow-img {\r\n      width: 21px !important;\r\n\r\n      height: 21px !important;\r\n    }\r\n\r\n\r\n    /* Project card */\r\n\r\n    .project-details-card {\r\n      padding: 12px;\r\n\r\n      margin-top: 12px;\r\n    }\r\n\r\n\r\n    /* Header */\r\n\r\n    .project-header {\r\n      flex-direction: column;\r\n\r\n      align-items: stretch;\r\n\r\n      gap: 10px;\r\n    }\r\n\r\n    .first-header {\r\n      width: 100%;\r\n    }\r\n\r\n    .project-title {\r\n      font-size: 12px;\r\n    }\r\n\r\n\r\n    /* Search */\r\n\r\n    .search-container {\r\n      width: 100%;\r\n\r\n      min-width: 0;\r\n\r\n      height: 34px;\r\n    }\r\n\r\n\r\n    /* Normal table */\r\n\r\n    .table-wrapper {\r\n      width: 100%;\r\n\r\n      overflow-x: auto;\r\n    }\r\n\r\n    .project-table {\r\n      min-width: 750px;\r\n    }\r\n\r\n\r\n    /* Demand */\r\n\r\n    .demand-liability-scroll {\r\n      width: 100%;\r\n\r\n      overflow-x: auto;\r\n\r\n      overflow-y: hidden;\r\n\r\n      -webkit-overflow-scrolling: touch;\r\n    }\r\n\r\n    .demand-liability-table {\r\n      width: 900px !important;\r\n\r\n      min-width: 900px !important;\r\n    }\r\n\r\n\r\n    /* Pagination */\r\n\r\n    .demand-pagination {\r\n      flex-direction: column;\r\n\r\n      align-items: center;\r\n\r\n      justify-content: center;\r\n\r\n      gap: 10px;\r\n\r\n      padding: 10px 0;\r\n    }\r\n\r\n    .demand-showing-text {\r\n      width: 100%;\r\n\r\n      text-align: center;\r\n\r\n      font-size: 11px !important;\r\n    }\r\n\r\n    .demand-pagination-controls {\r\n      width: 100%;\r\n\r\n      justify-content: center;\r\n\r\n      margin-left: 0;\r\n\r\n      gap: 14px;\r\n\r\n      flex-wrap: wrap;\r\n    }\r\n\r\n    .demand-page-numbers {\r\n      gap: 10px;\r\n    }\r\n\r\n    .demand-page-btn,\r\n    .demand-page-number,\r\n    .demand-page-dots {\r\n      font-size: 11px !important;\r\n    }\r\n\r\n\r\n    /* Old pagination */\r\n\r\n    .pagination-footer {\r\n      flex-direction: column;\r\n\r\n      gap: 10px;\r\n\r\n      align-items: center;\r\n    }\r\n\r\n    .pagination-controls {\r\n      justify-content: center;\r\n\r\n      flex-wrap: wrap;\r\n    }\r\n  }\r\n\r\n\r\n  /* =========================================================\r\n    MOBILE\r\n    401px - 576px\r\n  ========================================================= */\r\n\r\n  @media (max-width: 576px) {\r\n\r\n    .dashboard-main-width {\r\n      width: calc(100% - 16px);\r\n    }\r\n\r\n\r\n    /* Scheme */\r\n\r\n    .scheme-card {\r\n      padding: 10px;\r\n\r\n      margin-bottom: 12px;\r\n    }\r\n\r\n    .scheme-label {\r\n      font-size: 10px;\r\n    }\r\n\r\n    .scheme-select {\r\n      height: 34px;\r\n\r\n      font-size: 16px;\r\n    }\r\n\r\n\r\n    /* Metric cards */\r\n\r\n    .metric-cards-row {\r\n      grid-template-columns: 1fr;\r\n\r\n      gap: 10px;\r\n    }\r\n\r\n    .metric-card {\r\n      height: 72px;\r\n\r\n      padding: 7px 10px;\r\n    }\r\n\r\n    .metric-icon {\r\n      width: 36px;\r\n\r\n      min-width: 36px;\r\n    }\r\n\r\n    .metric-content {\r\n      margin-left: 7px;\r\n    }\r\n\r\n    .metric-label {\r\n      font-size: 10px !important;\r\n    }\r\n\r\n    .metric-value {\r\n      font-size: 11px !important;\r\n    }\r\n\r\n\r\n    /* Project */\r\n\r\n    .project-details-card {\r\n      padding: 10px;\r\n\r\n      border-radius: 9px;\r\n\r\n      margin-top: 10px;\r\n    }\r\n\r\n    .first-header img {\r\n      width: 20px;\r\n\r\n      height: 20px;\r\n    }\r\n\r\n    .project-title {\r\n      font-size: 11px;\r\n    }\r\n\r\n\r\n    /* Normal table */\r\n\r\n    .project-table {\r\n      min-width: 700px;\r\n    }\r\n\r\n    .project-table thead th {\r\n      font-size: 9px !important;\r\n    }\r\n\r\n    .project-table tbody td {\r\n      font-size: 9px !important;\r\n    }\r\n\r\n\r\n    /* Demand */\r\n\r\n    .demand-liability-table {\r\n      width: 850px !important;\r\n\r\n      min-width: 850px !important;\r\n    }\r\n\r\n    .demand-liability-table thead th {\r\n      font-size: 14px !important;\r\n    }\r\n\r\n    .demand-liability-table tbody td {\r\n      font-size: 9px !important;\r\n    }\r\n\r\n\r\n    /* Status */\r\n\r\n    .demand-liability-table .status-pending,\r\n    .demand-liability-table .status-approved {\r\n      width: 70px;\r\n\r\n      min-width: 70px;\r\n\r\n      height: 25px;\r\n\r\n      font-size: 9px;\r\n    }\r\n\r\n\r\n    /* Pagination */\r\n\r\n    .demand-pagination {\r\n      padding: 8px 0;\r\n\r\n      gap: 8px;\r\n    }\r\n\r\n    .demand-showing-text {\r\n      font-size: 10px !important;\r\n    }\r\n\r\n    .demand-pagination-controls {\r\n      gap: 9px;\r\n    }\r\n\r\n    .demand-page-numbers {\r\n      gap: 8px;\r\n    }\r\n\r\n    .demand-page-btn,\r\n    .demand-page-number,\r\n    .demand-page-dots {\r\n      font-size: 10px !important;\r\n    }\r\n  }\r\n\r\n\r\n  /* =========================================================\r\n    SMALL MOBILE\r\n    <= 400px\r\n  ========================================================= */\r\n\r\n  @media (max-width: 400px) {\r\n\r\n    .dashboard-main-width {\r\n      width: calc(100% - 12px);\r\n    }\r\n\r\n\r\n    /* Metric */\r\n\r\n    .metric-card {\r\n      height: 68px;\r\n    }\r\n\r\n    .metric-icon {\r\n      width: 32px;\r\n\r\n      min-width: 32px;\r\n\r\n      height: 32px;\r\n    }\r\n\r\n    .metric-icon img {\r\n      width: 32px !important;\r\n\r\n      height: 32px !important;\r\n    }\r\n\r\n    .metric-label {\r\n      font-size: 9px !important;\r\n    }\r\n\r\n    .metric-value {\r\n      font-size: 10px !important;\r\n    }\r\n\r\n\r\n    /* Project */\r\n\r\n    .project-details-card {\r\n      padding: 8px;\r\n    }\r\n\r\n    .project-title {\r\n      font-size: 10px;\r\n    }\r\n\r\n\r\n    /* Normal table */\r\n\r\n    .project-table {\r\n      min-width: 650px;\r\n    }\r\n\r\n\r\n    /* Demand */\r\n\r\n    .demand-liability-table {\r\n      width: 800px !important;\r\n\r\n      min-width: 800px !important;\r\n    }\r\n\r\n    .demand-liability-table thead th {\r\n      font-size: 8px !important;\r\n    }\r\n\r\n    .demand-liability-table tbody td {\r\n      font-size: 8px !important;\r\n    }\r\n\r\n\r\n    /* Status */\r\n\r\n    .demand-liability-table .status-pending,\r\n    .demand-liability-table .status-approved {\r\n      width: 65px;\r\n\r\n      min-width: 65px;\r\n\r\n      height: 24px;\r\n\r\n      font-size: 8px;\r\n    }\r\n\r\n\r\n    /* Pagination */\r\n\r\n    .demand-pagination {\r\n      gap: 7px;\r\n    }\r\n\r\n    .demand-pagination-controls {\r\n      gap: 7px;\r\n    }\r\n\r\n    .demand-page-numbers {\r\n      gap: 6px;\r\n    }\r\n\r\n    .demand-page-btn,\r\n    .demand-page-number,\r\n    .demand-page-dots {\r\n      font-size: 9px !important;\r\n    }\r\n  }\r\n\r\n\r\n  /* =========================================================\r\n    TOUCH / MOBILE SCROLL\r\n  ========================================================= */\r\n\r\n  @media (hover: none) and (pointer: coarse) {\r\n\r\n    .table-wrapper,\r\n    .demand-liability-scroll {\r\n      -webkit-overflow-scrolling: touch;\r\n    }\r\n  }\r\n\r\n  .metric-card {\r\n  width: 100%;\r\n  min-height: 90px;   /* instead of fixed height */\r\n  height: auto;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 10px;\r\n  border-radius: 12px;\r\n  box-sizing: border-box;\r\n  transition: transform 0.2s ease;\r\n}\r\n.metric-content {\r\n  flex: 1;\r\n  min-width: 0;\r\n  margin-left: 8px;\r\n  margin-right: 4px;\r\n}\r\n.metric-label {\r\n  font-size: 13px !important;\r\n  font-weight: 550;\r\n  color: #3f4344;\r\n  line-height: 1.25;\r\n  margin-bottom: 3px;\r\n\r\n  white-space: normal;      /* allow 2 lines */\r\n  overflow: visible;\r\n  text-overflow: unset;\r\n  word-break: break-word;\r\n}\r\n\r\n.scheme-card {\r\n  width: 94%;\r\n  min-height: 82px;\r\n\r\n  background: #f0f7ff;\r\n  border: 1px solid #9acbff;\r\n  border-radius: 10px;\r\n\r\n  display: flex;\r\n  align-items: center;\r\n\r\n  padding: 12px 16px;\r\n  margin: 18px auto;\r\n\r\n  box-sizing: border-box;\r\n}\r\n\r\n.scheme-label {\r\n  flex: 0 0 auto;\r\n\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #111827;\r\n\r\n  margin-right: 6px;\r\n}\r\n\r\n.scheme-select-wrapper {\r\n  width: 78%;\r\n  max-width: 720px;\r\n}\r\n\r\n.scheme-select {\r\n  width: 100%;\r\n}\r\n\r\n.scheme__control {\r\n  min-height: 38px !important;\r\n  height: 38px !important;\r\n\r\n  border: 1px solid #c7c7c7 !important;\r\n  border-radius: 5px !important;\r\n\r\n  background: #fff !important;\r\n\r\n  box-shadow: none !important;\r\n}\r\n\r\n.scheme__control:hover {\r\n  border-color: #aaa !important;\r\n}\r\n\r\n.scheme__control--is-focused {\r\n  border-color: #2684ff !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.scheme__value-container {\r\n  height: 36px !important;\r\n  padding: 0 10px !important;\r\n}\r\n\r\n.scheme__placeholder {\r\n  color: #555 !important;\r\n  font-size: 14px;\r\n}\r\n\r\n.scheme__single-value {\r\n  font-size: 14px;\r\n  color: #111827 !important;\r\n}\r\n\r\n.scheme__indicators {\r\n  height: 36px;\r\n}\r\n\r\n.scheme__indicator {\r\n  padding: 8px !important;\r\n}\r\n\r\n.scheme__indicator-separator {\r\n  display: none;\r\n}\r\n\r\n.scheme__menu {\r\n  z-index: 9999;\r\n}\r\n\r\n\r\n\r\n  /* 22-10 static msg */\r\n\r\n.demand-liability-scroll {\r\n  position: relative;\r\n  width: 100%;\r\n  overflow-x: auto;\r\n}\r\n\r\n.demand-no-records {\r\n  position: sticky;\r\n  left: 0;\r\n  width: 100%;\r\n  min-width: 100%;\r\n  height: 100px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: #ffffff;\r\n  color: #555;\r\n  font-size: 14px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n\r\n/* 28-10 */\r\n/* =========================================================\r\n   MAIN DASHBOARD (matches design image)\r\n========================================================= */\r\n.pd-page { background: #eaebff; padding: 0 0 20px; }\r\n\r\n.pd-title-wrap { padding: 12px 10px 10px; }\r\n.pd-subtitle { font-size: 10px; color: #6b7280; font-weight: 500; }\r\n.pd-title { font-size: 14px; font-weight: 700; color: #111827; }\r\n\r\n/* Scheme bar */\r\n.pd-scheme-bar {\r\n  display: flex; align-items: center; gap: 18px;\r\n  background:linear-gradient(rgb(4, 76, 146), rgb(0, 113, 188), rgb(2, 47, 90)); padding: 22px 34px; margin-bottom: 16px;\r\n}\r\n.pd-scheme-label { color: #fff; font-size: 12px; font-weight: 600; margin: 0; white-space: nowrap; }\r\n.pd-scheme-select { flex: 1; }\r\n.pd-scheme-bar .scheme__control {\r\n  background: #fff !important; border: 1px solid #2d4f8f !important;\r\n  min-height: 34px !important; height: 34px !important; border-radius: 6px !important;\r\n}\r\n.pd-scheme-bar .scheme__value-container { height: 32px !important; }\r\n.pd-scheme-bar .scheme__placeholder,\r\n.pd-scheme-bar .scheme__single-value,\r\n.pd-scheme-bar .scheme__input-container { color:#726b6b !important; font-size: 12px; }\r\n.pd-scheme-bar .scheme__indicator { color: #726b6b !important; padding: 6px !important; }\r\n.pd-scheme-bar .scheme__menu { color: #111; }\r\n\r\n/* White cards */\r\n.pd-card {\r\n  background: #fff; border-radius: 12px; padding: 16px 20px;\r\n  margin: 0 20px 18px; box-shadow: 0 2px 8px rgba(0, 0, 0, .12);\r\n}\r\n.pd-card-title { font-size: 16px; font-weight: 700; color: #111827; margin-bottom: 14px; }\r\n\r\n/* Metric cards */\r\n.pd-metrics { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 24px; }\r\n.pd-metric {\r\n  position: relative; border: 1px solid; border-radius: 12px;\r\n  padding: 14px 16px 12px; min-height: 112px;\r\n  display: flex; flex-direction: column;\r\n}\r\n.pd-metric-arrow {\r\n  position: absolute; top: 10px; right: 10px; width: 20px; height: 20px;\r\n  border-radius: 50%; display: flex; align-items: center; justify-content: center;\r\n}\r\n.pd-metric-icon {\r\n  width: 34px; height: 34px; border-radius: 50%; margin-bottom: 8px;\r\n  display: flex; align-items: center; justify-content: center;\r\n}\r\n.pd-metric-icon img { width: 20px; height: 20px; object-fit: contain; }\r\n.pd-metric-label { font-size: 14px; font-weight: 600; color: #222; }\r\n.pd-metric-value { font-size: 12px; font-weight: 800; color: #111; margin: 2px 0 10px; }\r\n.pd-metric-bar { margin-top: auto; height: 4px; border-radius: 4px; background: #c9ccd1; overflow: hidden; }\r\n.pd-metric-bar span { display: block; height: 100%; border-radius: 4px; }\r\n\r\n.pd-blue   { color: #1a73c8; }\r\n.pd-metric.pd-blue   { background: #f3f8fd; border-color: #3d87c9; }\r\n.pd-metric.pd-blue .pd-metric-arrow, .pd-metric.pd-blue .pd-metric-bar span { background: #2e86d4; }\r\n.pd-metric.pd-blue .pd-metric-icon { background: #dcebf8; }\r\n\r\n.pd-metric.pd-purple { background: #f7f7fd; border-color: #9a91ff; }\r\n.pd-metric.pd-purple .pd-metric-arrow, .pd-metric.pd-purple .pd-metric-bar span { background: #7b6df0; }\r\n.pd-metric.pd-purple .pd-metric-icon { background: #e6e3fb; }\r\n\r\n.pd-metric.pd-green  { background: #f1fbf4; border-color: #7fcf93; }\r\n.pd-metric.pd-green .pd-metric-arrow, .pd-metric.pd-green .pd-metric-bar span { background: #3a9d8c; }\r\n.pd-metric.pd-green .pd-metric-icon { background: #d8f0dd; }\r\n\r\n.pd-metric.pd-orange { background: #fffaf1; border-color: #f3a65e; }\r\n.pd-metric.pd-orange .pd-metric-arrow, .pd-metric.pd-orange .pd-metric-bar span { background: #ec8a35; }\r\n.pd-metric.pd-orange .pd-metric-icon { background: #fbe7cf; }\r\n\r\n/* Project details panel */\r\n.pd-details-panel { background: #eef1f6; border-radius: 10px; padding: 14px 14px 16px; }\r\n.pd-details-header { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 12px; }\r\n.pd-details-title { display: flex; align-items: center; gap: 8px; font-size: 16px; font-weight: 700; color: #111; }\r\n.pd-details-title img { width: 16px; height: 16px; }\r\n.pd-search {\r\n  display: flex; align-items: center; gap: 6px; width: 224px; height: 30px;\r\n  background: #fff; border: 1px solid #d6dbe6; border-radius: 8px; padding: 0 10px;\r\n}\r\n.pd-search img { width: 20px; height: 20px; }\r\n.pd-search input { border: none; outline: none; width: 100%; font-size: 12px; background: transparent; }\r\n\r\n.pd-table-card {\r\n  background: #fff; border-radius: 10px; padding: 16px 18px;\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, .12);\r\n}\r\n.pd-table-scroll { overflow-x: auto; }\r\n.pd-table { width: 100%; border-collapse: collapse; font-size: 10px; }\r\n.pd-table thead th {\r\n  background: #2f7bd9; color: #fff; font-weight: 600; font-size: 12px;\r\n  padding: 9px 8px; text-align: center; border: 1px solid #fff; white-space: nowrap;\r\n}\r\n.pd-table tbody td {\r\n  padding: 10px 10px; border: 1px solid #fff; color: #111; font-weight: 500;\r\n  vertical-align: middle; font-size: 12px;\r\n}\r\n.pd-table tbody tr:nth-child(odd)  { background: #e7f4fb; }\r\n.pd-table tbody tr:nth-child(even) { background: #cfe5f2; }\r\n.pd-table td.c { text-align: center; }\r\n.pd-table td.l { text-align: center; }\r\n.pd-table td.r { text-align: center; }\r\n.pd-table td.pd-green { color: #0a9a55; font-weight: 700; text-align: center;}\r\n.pd-table td.pd-blue  { color: #1a73c8; font-weight: 700; text-align: center;}\r\n.pd-cost { font-weight: 700 !important; }\t\t\t\r\n.pd-cost img { width: 13px; height: 13px; margin-right: 8px; vertical-align: middle; }\r\n\r\n/* Pagination */\r\n.pd-pagination { display: flex; align-items: center; justify-content: space-between; margin-top: 14px; }\r\n.pd-showing { margin: 0; font-size: 12px; font-weight: 600; color: #222; }\r\n.pd-pages { display: flex; gap: 6px; }\r\n.pd-pages button {\r\n  min-width: 30px; height: 26px; border: none; border-radius: 4px; background: #fff;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, .25); color: #444; font-size: 12px; cursor: pointer;\r\n}\r\n.pd-pages button.active { background: linear-gradient(180deg, #1c7fd6, #0f5fb0); color: #fff; font-weight: 700; }\r\n.pd-pages button:disabled { opacity: .45; cursor: not-allowed; }\r\n\r\n/* Responsive */\r\n@media (max-width: 992px) { .pd-metrics { grid-template-columns: repeat(2, minmax(0, 1fr)); } }\r\n@media (max-width: 576px) {\r\n  .pd-metrics { grid-template-columns: 1fr; }\r\n  .pd-scheme-bar { flex-direction: column; align-items: stretch; gap: 8px; padding: 14px; }\r\n  .pd-card { margin: 0 8px 14px; padding: 12px; }\r\n  .pd-details-header, .pd-pagination { flex-direction: column; align-items: stretch; gap: 10px; }\r\n  .pd-search { width: 100%; }\r\n  .pd-pages { justify-content: center; }\r\n  .pd-table { min-width: 650px; }\r\n}\r\n\r\n\r\n/* ---------- Project Overview: darker card colors ---------- */\r\n\r\n/* 1. Demand Against Liability (blue) */\r\n.pd-metric.pd-blue {\r\n  background: #eaf3fc;\r\n  border: 1.5px solid #1a6fc4;\r\n}\r\n.pd-metric.pd-blue .pd-metric-arrow,\r\n.pd-metric.pd-blue .pd-metric-bar span { background: #1a6fc4; }\r\n.pd-metric.pd-blue .pd-metric-icon { background: #bcd9f3; }\r\n\r\n/* 2. Total Liability (purple) */\r\n.pd-metric.pd-purple {\r\n  background: #f0eefd;\r\n  border: 1.5px solid #6c5ce7;\r\n}\r\n.pd-metric.pd-purple .pd-metric-arrow,\r\n.pd-metric.pd-purple .pd-metric-bar span { background: #5b4bd5; }\r\n.pd-metric.pd-purple .pd-metric-icon { background: #d3cdf8; }\r\n\r\n/* 3. Available Balance (green) */\r\n.pd-metric.pd-green {\r\n  background: #e8f7ec;\r\n  border: 1.5px solid #2e9e5b;\r\n}\r\n.pd-metric.pd-green .pd-metric-arrow,\r\n.pd-metric.pd-green .pd-metric-bar span { background: #1f7a6d; }\r\n.pd-metric.pd-green .pd-metric-icon { background: #bfe6c9; }\r\n\r\n/* 4. Excess / Shortfall (orange) */\r\n.pd-metric.pd-orange {\r\n  background: #fff3e3;\r\n  border: 1.5px solid #e8761a;\r\n}\r\n.pd-metric.pd-orange .pd-metric-arrow,\r\n.pd-metric.pd-orange .pd-metric-bar span { background: #e8761a; }\r\n.pd-metric.pd-orange .pd-metric-icon { background: #fad3a6; }\r\n\r\n/* Darker grey track behind the progress bar */\r\n.pd-metric-bar { background: #b4b9c2; height: 5px; }\r\n\r\n/* Stronger text and more visible icons */\r\n.pd-metric-label { color: #111827; font-weight: 700; }\r\n.pd-metric-value { color: #0b0f1a; }\r\n.pd-metric-icon img { opacity: 1; filter: saturate(1.6) contrast(1.15); }\r\n/* Keep a disabled arrow (Demand = ₹0) readable, not washed out */\r\n.pd-metric-arrow[style*=\"opacity: 0.4\"] { opacity: 0.55 !important; }\r\n\r\n\r\n\r\n/* Available Balance amount → green */\r\n.pd-metric.pd-green .pd-metric-value { color: #1a9a4a; }\r\n\r\n/* Excess / Sh\r\nortfall amount → red */\r\n.pd-metric.pd-orange .pd-metric-value { color: #e11d23; }\r\n\r\n\r\n\r\n/* Plain text pagination: ‹ Previous  1  Next › */\r\n.pd-pages.pd-pages-text {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 22px;\r\n}\r\n\r\n.pd-pages-text button {\r\n  min-width: 0;\r\n  height: auto;\r\n  padding: 0;\r\n  border: none;\r\n  border-radius: 0;\r\n  background: transparent;\r\n  box-shadow: none;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n}\r\n\r\n/* Previous / Next */\r\n.pd-pages-text .pd-nav {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  color: #2ea4e7;\r\n}\r\n.pd-pages-text .pd-nav:hover:not(:disabled) { color: #147fc0; }\r\n.pd-pages-text .pd-nav:disabled {\r\n  color: #b5b5b5;\r\n  cursor: not-allowed;\r\n  opacity: 1;\r\n}\r\n.pd-chev { font-size: 16px; line-height: 1; }\r\n\r\n/* Page numbers */\r\n.pd-pages-text .pd-num { color: #b5b5b5; }\r\n.pd-pages-text .pd-num:hover { color: #2ea4e7; }\r\n.pd-pages-text .pd-num.active {\r\n  color: #2ea4e7;\r\n  text-decoration: underline;\r\n  text-underline-offset: 3px;\r\n  background: transparent;   /* cancels the old blue box */\r\n}\r\n\r\n.pd-metric.pd-orange .pd-metric-arrow { display: none; }\r\n\r\n\r\n\r\n/* ---------- Drill-down tables (same look as Project Details) ---------- */\r\n\r\n/* Back button in the title */\r\n.pd-back {\r\n  width: 26px; height: 26px; padding: 0; margin-right: 4px;\r\n  border: none; border-radius: 6px; background: #fff;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, .2);\r\n  display: inline-flex; align-items: center; justify-content: center; cursor: pointer;\r\n}\r\n.pd-back img { width: 14px; height: 14px; object-fit: contain; }\r\n.pd-back:hover { background: #e7f4fb; }\r\n\r\n/* Wide tables scroll sideways instead of squeezing */\r\n.pd-table.pd-wide { min-width: 900px; }\r\n.pd-table thead th { white-space: normal; line-height: 1.25; }\r\n\r\n/* Cell colors */\r\n.pd-table td.pd-link { color: #5295c9; font-weight: 600; }\r\n.pd-table td.pd-red  { color: #e11d23; font-weight: 600; }\r\n\r\n/* Status badges */\r\n.pd-badge {\r\n  display: inline-flex; align-items: center; justify-content: center;\r\n  min-width: 74px; height: 22px; padding: 0 10px;\r\n  border-radius: 12px; font-size: 10px; font-weight: 700; color: #fff;\r\n}\r\n.pd-badge.approved { background: #1a9a4a; }\r\n.pd-badge.pending  { background: #e11d23; }\r\n\r\n/* Empty state (stays centered even when the table scrolls) */\r\n.pd-empty {\r\n  position: sticky; left: 0; width: 100%;\r\n  height: 90px; display: flex; align-items: center; justify-content: center;\r\n  background: #fff; color: #555; font-size: 12px;\r\n}\r\n\r\n/* Pagination ellipsis */\r\n.pd-pages-text .pd-dots { color: #b5b5b5; font-size: 12px; font-weight: 700; }\r\n\r\n/* Mobile */\r\n@media (max-width: 576px) {\r\n  .pd-details-title span { font-size: 11px; }\r\n}\r\n\r\n\r\n/* Back button */\r\n.pd-details-title .pd-back {\r\n  width: 36px !important;\r\n  height: 36px !important;\r\n  min-width: 36px;\r\n  padding: 0 !important;\r\n  margin: 0 6px 0 0;\r\n  border: none !important;\r\n  border-radius: 8px;\r\n  background: #fff;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, .25);\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.pd-details-title .pd-back img {\r\n  width: 24px !important;     /* make bigger / smaller here */\r\n  height: 24px !important;\r\n  object-fit: contain;\r\n  display: block;\r\n}\r\n\r\n.pd-details-title .pd-back:hover { background: #e7f4fb; }\r\n\r\n/* ---------- Icon circle: solid color + white icon ---------- */\r\n.pd-metric-icon {\r\n  width: 36px;\r\n  height: 36px;\r\n}\r\n\r\n\r\n.pd-metric.pd-blue   .pd-metric-icon { background: #1f5fa8; }\r\n.pd-metric.pd-purple .pd-metric-icon { background: #8e3fb0; }\r\n.pd-metric.pd-green  .pd-metric-icon { background: #1f8a5b; }\r\n.pd-metric.pd-orange .pd-metric-icon { background: #d2691e; }\r\n\r\n/* ---------- Arrow: outlined circle in the card color ---------- */\r\n.pd-metric-arrow {\r\n  width: 20px;\r\n  height: 20px;\r\n  background: transparent !important;\r\n  border: 1.5px solid currentColor;\r\n  box-sizing: border-box;\r\n}\r\n.pd-metric.pd-blue   .pd-metric-arrow { color: #2e86d4; }\r\n.pd-metric.pd-purple .pd-metric-arrow { color: #8e3fb0; }\r\n.pd-metric.pd-green  .pd-metric-arrow { color: #1f8a5b; }\r\n.pd-metric.pd-orange .pd-metric-arrow { color: #d2691e; }\r\n\r\n/* ---------- Card border + background (same family as the reference) ---------- */\r\n.pd-metric.pd-blue   { background: #eef3fb; border: 1.5px solid #4a90d9; }\r\n.pd-metric.pd-purple { background: #f6f0fa; border: 1.5px solid #a05cc0; }\r\n.pd-metric.pd-green  { background: #e9f6ef; border: 1.5px solid #2e9e6b; }\r\n.pd-metric.pd-orange { background: #fff4ea; border: 1.5px solid #e8903a; }\r\n\r\n/* =========================================================\r\n   TABLE: light-blue bordered style (all dashboard tables)\r\n========================================================= */\r\n\r\n/* Outer frame with rounded corners */\r\n.pd-table {\r\n  width: 100%;\r\n  border-collapse: separate;      /* needed for rounded corners */\r\n  border-spacing: 0;\r\n  border: 1.5px solid #a9cdf5;\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n  background: #fff;\r\n}\r\n\r\n/* Header */\r\n.pd-table thead th {\r\n  background: #2f7bd9;\r\n  color: #fff;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  padding: 11px 8px;\r\n  text-align: center;\r\n  border: 0;\r\n  border-right: 1px solid rgba(255, 255, 255, .45);\r\n  border-bottom: 1px solid #a9cdf5;\r\n}\r\n.pd-table thead th:last-child { border-right: 0; }\r\n\r\n/* Body cells: light-blue grid lines */\r\n.pd-table tbody td {\r\n  padding: 12px 10px;\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  color: #111;\r\n  border: 0;\r\n  border-right: 1px solid #b7d6f4;\r\n  border-bottom: 1px solid #b7d6f4;\r\n  vertical-align: middle;\r\n}\r\n.pd-table tbody td:last-child { border-right: 0; }\r\n.pd-table tbody tr:last-child td { border-bottom: 0; }\r\n\r\n/* Row colors */\r\n.pd-table tbody tr:nth-child(odd)  { background: #e6f3fc; }\r\n.pd-table tbody tr:nth-child(even) { background: #cfe4f2; }\r\n.pd-table tbody tr:hover { background: #bcdcf3; }\r\n\r\n/* Alignment + amount colors */\r\n.pd-table td.c { text-align: center; }\r\n.pd-table td.l { text-align: center; padding-left: 14px; }\r\n.pd-table td.r { text-align: center; padding-right: 16px; }\r\n.pd-table td.pd-green { color: #12a05c; font-weight: 700; }\r\n.pd-table td.pd-blue  { color: #2a7fd0; font-weight: 700; }\r\n.pd-table td.pd-red   { color: #e11d23; font-weight: 700; }\r\n.pd-table td.pd-link  { color: #5295c9; font-weight: 700; }\r\n\r\n/* Approved cost with green tick */\r\n.pd-cost { font-weight: 700 !important; }\r\n.pd-cost img {\r\n  width: 14px;\r\n  height: 14px;\r\n  margin-right: 10px;\r\n  vertical-align: middle;\r\n}\r\n/* Tables: 4px corners */\r\n.pd-table,\r\n.budgetContainer .dg-panel .tableContainer table {\r\n  border-radius: 5px !important;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n.pd-metric:hover {\r\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);\r\n  transform: translateY(-2px);\r\n  transition: all 0.2s ease;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
